/* Final two estimators: approved October25 controls; staging only, owner publishes. */
/* SLD centralized estimator controls. Engineering Database v2.63 / maintained Library revision144. October25 Round Bottom Stuff Sack owner-approved controls; existing controls retained. Saved unpublished theme only; owner publishes. Legacy fabric.sack fields are retained for source history; current tarp calculations use mainSackWeight. */
(function(root){'use strict';
const groundHardware=Object.freeze({loopOnly:Object.freeze({weight:0}),lineLoc3:Object.freeze({weight:0.044}),lineLockV:Object.freeze({weight:0.041}),lineLockLite10:Object.freeze({weight:0.039}),lineLockLite15:Object.freeze({weight:0.038}),dRing:Object.freeze({weight:0.015})});
const grosgrain=Object.freeze({quarterPerInch:0.009/6,threeEighthPerInch:0.0016666666666666666,oneHalfPerInch:0.0023333333333333335,fiveEighthPerInch:0.0023333333333333335});
const tarpGroundAssemblies=Object.freeze({
  loopOnly:Object.freeze({ridge:0.014,corner:0.0105,side:0.008166666666666668}),
  lineLoc3:Object.freeze({ridge:0.058,corner:0.0545,side:0.05216666666666667}),
  lineLockV:Object.freeze({ridge:0.055,corner:0.0515,side:0.04916666666666667}),
  lineLockLite10:Object.freeze({ridge:0.049,corner:0.0465,side:0.044833333333333336}),
  lineLockLite15:Object.freeze({ridge:0.052,corner:0.0485,side:0.04616666666666667}),
  dRing:Object.freeze({ridge:0.09127272727272727,corner:0.075,side:0.0706})
});
// Shared planning allowance; historical direct sack observations stay in Engineering.
function tarpMainSackWeight(areaSqIn,isSilpoly16,poleCount){
  if(!Number.isFinite(areaSqIn)||areaSqIn<=0)return null;
  const m=tarpControls.mainSackModel;
  const t=Math.max(0,Math.min(1,(areaSqIn/1296-m.areaMin)/(m.areaMax-m.areaMin)));
  return m.baseMin+(m.baseMax-m.baseMin)*t*t*(3-2*t)+(isSilpoly16?m.silpoly16Extra:0)+(poleCount>0?m.poleExtra:0);
}
const tarpControls=Object.freeze({
  groundAssemblies:tarpGroundAssemblies,
  poles:Object.freeze({weightPerInch:0.05560798548094374,sleeveWeightEach:0.05375,sleevesPerPole:2,sackByCount:Object.freeze({1:0.218,2:0.258,3:0.298})}),
  internalRidgeline:Object.freeze({baseLengthFeet:10,baseWeightAt10Feet:0.701,perFootAdjustment:0.025,anchorWeight:groundHardware.dRing.weight+groundHardware.lineLockV.weight+2*grosgrain.fiveEighthPerInch}),
  mainSackModel:Object.freeze({baseMin:0.30,baseMax:0.50,areaMin:4,areaMax:16,silpoly16Extra:0.10,poleExtra:0.10,algorithm:'smoothstep-area-v1'}),
  mainSackWeight:tarpMainSackWeight,
  // Webbing-loop assembly: owner Oct28 measurement, four complete assemblies = 0.300 oz; sealing separate.
  sidePulls:Object.freeze({assemblySet:0.61,sealIncrement:0.0753,webbingLoopEach:0.075}),
  twoPanelSeam:Object.freeze({baseSealPerFoot:0.005744444444444444,hemThread:0.048}),
  havenConstruction:Object.freeze({cornerLoopLength:4.5,midpointLoopLength:3.5,midpointReinforcement:0.0053,fiveInTriangleReinforcement:0.0429,havenBaseReinforcement:0.348,perimeterReinforcementNoSnaps:0.272,perimeterReinforcementWithSnaps:0.3076,ridgeReinforcement:0.1658,fixedRidgeTies:0.16,doorSnapWeightEach:0.027,doorBottomCutbackArea:564,shortCurveChord:47.38143096192854,longSpanCornerCutLength:94,shortCatFactor:0.8,longCatFactor:0.57})
});
const hammockControls=Object.freeze({
  continuousLoops:Object.freeze({permanent:0.182,removable:0.228}),
  ridgelines:Object.freeze({
    fixedByLength:Object.freeze({8:0.41,9:0.46,10:0.51,11:0.56,12:0.61}),
    adjustableByLength:Object.freeze({8:0.664,9:0.7243333333333334,10:0.7243333333333334,11:0.807,12:0.807}),
    fixed:Object.freeze({baseLengthFeet:11,baseWeight:0.56,perFootAdjustment:0.05})
  })
});
const shared=Object.freeze({
  fabrics:Object.freeze({
    tarp:Object.freeze({
      darkOliveSilnylon:Object.freeze({planningDensity:1.2410063272769492,usableWidth:59}),
      silnylon11Generic:Object.freeze({planningDensity:1.2,usableWidth:59}),
      xenon11Charcoal:Object.freeze({planningDensity:1.1619849449913144,usableWidth:58.875}),
      xenon11Coyote:Object.freeze({planningDensity:1.138665564283,usableWidth:59}),
      xenon11Moroccan:Object.freeze({planningDensity:1.1859363057324839,usableWidth:58.875}),
      xenon11Ordered:Object.freeze({planningDensity:1.1752780249303483,usableWidth:59}),
      xenon09:Object.freeze({planningDensity:0.9492735332,usableWidth:59}),
      xenonWide:Object.freeze({planningDensity:1.1,usableWidth:71}),
      silpoly11Generic:Object.freeze({planningDensity:1.24,usableWidth:59}),
      silpoly16Generic:Object.freeze({planningDensity:1.73,usableWidth:59}),
      silpoly16Charcoal:Object.freeze({planningDensity:1.7262165868042758,usableWidth:59}),
      silpolyXLGeneric:Object.freeze({planningDensity:1.3,usableWidth:72})
    }),
    quilt:Object.freeze({
      ionBlack:Object.freeze({planningDensity:1.07,usableWidth:60}),ionGeneric:Object.freeze({planningDensity:1.1,usableWidth:60}),
      argon90Black:Object.freeze({planningDensity:5.978*1296/(141*59),usableWidth:59}),argon90Charcoal:Object.freeze({planningDensity:0.8984727272727274,usableWidth:60}),argon90Generic:Object.freeze({planningDensity:0.9,usableWidth:58}),argon67Generic:Object.freeze({planningDensity:0.67,usableWidth:58})
    }),
    hammock:Object.freeze({hexon16:Object.freeze({planningDensity:1.69,usableWidth:61}),hexon16DarkOlive:Object.freeze({planningDensity:1.707,usableWidth:60.75}),hexon16Moroccan:Object.freeze({planningDensity:1.694,usableWidth:61}),hexon12:Object.freeze({planningDensity:1.2,usableWidth:60}),hexonWide16:Object.freeze({planningDensity:1.69,usableWidth:73}),hexonWide16DarkOlive:Object.freeze({planningDensity:1.671,usableWidth:73}),hyperD16:Object.freeze({planningDensity:1.6,usableWidth:60}),monolite10:Object.freeze({planningDensity:1,usableWidth:63}),mtn12XL:Object.freeze({planningDensity:1.2,usableWidth:67}),mtn17XL:Object.freeze({planningDensity:1.6722,usableWidth:75}),hex70XL:Object.freeze({planningDensity:2.2,usableWidth:74})})
  }),
  netting:Object.freeze({
    nano:Object.freeze({planningDensity:3.230*1296/(116*53.75),usableWidth:53.75,referenceWidth:54,referenceDensity:0.703,referenceBase:4.573,baseline:106}),
    noSeeUm09:Object.freeze({planningDensity:0.88})
  }),
  insulation:Object.freeze({draftCollar:Object.freeze({planningDensity:1}),apex25:Object.freeze({planningDensity:2.5}),apex36:Object.freeze({planningDensity:3.5984826132771337}),apex50:Object.freeze({planningDensity:4.636312370421562}),apex60:Object.freeze({planningDensity:5.889357218124341}),apex75:Object.freeze({planningDensity:7.5}),apex100:Object.freeze({planningDensity:10})}),
  components:Object.freeze({groundHardware,grosgrain,zipperedStrapPocket:0.36,sackClosure:Object.freeze({shockCordSixteenthPerInch:0.241/124,blindDrawstringPerInch:0.306/156,lightDrawstringPerInch:0.012/11,catchAllDrawstringPerInch:0.107/62,tinyCordLock:0.018,largeCordLock:0.05,mediumCordLock:0.035})}),
  tarps:tarpControls,
  hammocks:hammockControls,
  suspension:Object.freeze({none:Object.freeze({weight:0,sack:0,includesLoops:false}),cinchBuckleStarter:Object.freeze({weight:8.835,sack:0.377,includesLoops:true}),cinchBuckleNonStarter:Object.freeze({weight:8.937,sack:0.377,includesLoops:true}),whoopieToggle:Object.freeze({weight:4.832,sack:0.191,includesLoops:false}),whoopieCarabiner:Object.freeze({weight:6.0895,sack:0.191,includesLoops:false}),whoopieHook:Object.freeze({weight:4.749,sack:0.191,includesLoops:false}),beetleBuckle:Object.freeze({weight:7.049,sack:0.296,includesLoops:false})}),
  hammockOptions:Object.freeze({addOnTieLoops:0.046,addOnTieDRings:0.09,uqHooks:0.239333,uqHooksDRings:0.3015,peakShelfOne:0.658,peakShelfBoth:1.316,smallRidgelinePouch:0.2035,zipperedPouch:0.463,zipperedStrapSack:0.358}),
  accessories:Object.freeze({none:0,glowire25:1.0125,glowire50:2.025,zingIt25:0.4413333333333334,tarpFlyzPair:0.15,flyzSplicedZingItPair:0.548,flyzSplicedLashItPair:0.556,patchKit:2}),
  sacks:Object.freeze({originalTrailDusterSilpolyXL:0.2964705882352941}),
  overrides:Object.freeze({
    trailWinder:Object.freeze({baseArgon67Width:60}),
    trailHaven:Object.freeze({lineLockVCorner:0.051500000000000004,dRingMidpoint:0.07081818181818182}),
    streamliner:Object.freeze({fabrics:Object.freeze({hexonDarkOlive:Object.freeze({planningDensity:1.707,usableWidth:60.75}),hexonMoroccan:Object.freeze({planningDensity:1.694,usableWidth:61}),hexonGeneric:Object.freeze({planningDensity:1.69,usableWidth:60})})})
  })
});
const productControls=Object.freeze({
gearHammock:Object.freeze({"bodyLength":57,"standardWidth":50,"waterproofWidth":51,"zipper3":0.48,"zipper5":1.185,"loopLashInches":20,"loopRemovable":0.228,"loopPermanent":0.182,"miniBinerEach":0.1054,"fullBinerEach":0.76,"binerCount":2,"lashPerFoot":0.01812,"suspensionLashFeet":20,"whoopiePair":1.489,"sack":0.31,"densities":{"charcoal":1.4,"greenTea":1.508983888292159,"foliage":1.894566176470588,"darkOlive":1.241006327276949}}),zipperedPouch:Object.freeze({"corduraAllowance":1.25,"otherAllowance":0.75,"foldFactor":2,"zipper3PerInch":0.00881923,"zipper5PerInch":0.0174,"slider3":0.069,"slider5":0.17,"tabCount":2,"tab3Length":3.5,"tab5Length":4,"tab3PerInch":0.0016666666666666666,"tab5GrosgrainPerInch":0.0023333333333333335,"tab5WebbingPerInch":0.00897560975609756,"densities":{"mesh":0.88,"darkOlive":1.241006327276949,"blaze":1.175278024930348,"charcoal":1.1619849449913144,"moroccan":1.185936305732484,"silpoly":1.726216586804276,"cordura500Multicam":8.935064150943395,"cordura750Black":6.868799999999999,"cordura1000Black":9.81,"cordura1000Coyote":9.7,"cordura1000CamoGreen":9.75,"cordura1000Multicam":9.398609896432681}}),
  roundBottomSack:Object.freeze({"minDiameter":4,"maxDiameter":12,"minLength":5,"maxLength":32,"sizeIncrement":1,"rawWidthExtra":2,"rawWidthStep":0.5,"rawLengthExtra":1.5,"rawLengthDiameterFactor":0.5,"smallCircleMaxDiameter":6,"smallCircleExtra":0.75,"largeCircleExtra":1,"smallHardwareMaxDiameter":8,"daisy":{"minimum":2,"lengthDeduction":4,"step":2,"endTackExtra":1},"webbing":{"threeQuarterPerInch":0.012238095238095239},"thread":{"base":0.012,"perDaisyTack":0.0007,"largeHandlePair":0.002},"algorithm":"round-bottom-sack-v1","woodlandDensity":1.7965325779036827,"status":"Owner-approved scoped model; thread remains provisional and unmeasured"}),
  dualSkins:Object.freeze({"pieceCount":2,"rawLengthsInches":Object.freeze({"9":68,"10":74,"11":80,"12":86,"13":92}),"standardWidth":10,"wideWidth":13,"narrowWidth":5,"grosgrainPiecesPerSkin":2,"grosgrainPieceInches":6,"drawstringExtraInches":3,"pocketDepth":12,"narrowPocketDepth":18,"mainThreadPerFoot":0.002,"pocketThreadEach":0.006,"algorithm":"dual-skins-linear-taper-v1"}),
  singleSkin:Object.freeze({"rawLengthExtraInches":6,"standardWidth":13,"wideWidth":15,"narrowWidth":5,"grosgrainPieceInches":6,"grosgrainPieces":2,"standardDrawstringInches":16,"wideDrawstringInches":18,"pocketDepth":12,"narrowPocketDepth":18,"threadPerFoot":0.002,"algorithm":"single-skin-linear-taper-v1"}),
  poleSack:Object.freeze({"minWidth":2,"maxWidth":10,"minLength":12,"maxLength":52,"sizeIncrement":1,"smallWebbingMaxWidth":4,"daisy":Object.freeze({"mediumStart":30,"longStart":41,"mediumAllowance":2.5,"longAllowance":3}),"webbing":Object.freeze({"baseLength":8.5,"baseSackLength":12,"step":2,"halfInchPerInch":0.00897560975609756,"fiveEighthPerInch":0.010878048780487806,"status":"PROVISIONAL product-scoped use; source samples migrated2026-10-23","halfInchSource":"libfile_a2b72f89b3388191a819e08de81f6f4d","fiveEighthSource":"libfile_6105ecc4d6d48191a8904f0e8dece954"})}),
  stakeSack:Object.freeze({
    rawWidthMultiplier:2,rawWidthExtra:2.25,rawLengthExtra:2,drawstringExtra:3,
    smallClosureMaxWidth:4,drawstringCount:1,cordLockCount:1,
    minWidth:2,maxWidth:6,minLength:6,maxLength:14,sizeIncrement:1,
    reinforcement:Object.freeze({width:3,lengthDeduction:0.5,weightPerInch:0.342/31.5,
      status:'PROVISIONAL product-scoped sample rate; source measurement migrated2026-10-23',
      source:'libfile_dea948e991848191812e60d597ed8db9',sample:'3 x 31.5 in = 0.342 oz'}),
    constructionAllowance:0,displayOunceDecimals:2,gramsPerOunce:28.3495
  }),
  catchAll:Object.freeze({
    rawBodyLengthInches:Object.freeze({ft9:105,ft9_5:110,ft10:115,ft10_5:120,ft11:125,ft11_5:130,ft12:135}),
    rawWidthInches:Object.freeze({standardWaterproof:28,standardNoSeeUm:27.375,wide:40}),
    vent:Object.freeze({widthInches:2.5}),
    closures:Object.freeze({
      standard:Object.freeze({drawstringsPair:0.107,total:0.179}),
      wide:Object.freeze({drawstringsPair:0.149,total:0.221}),
      mediumCordLocksPair:0.072
    }),
    constructionAllowance:0
  }),
  eclipse:Object.freeze({
    shockCordWeightPerInch:0.125/29,
    cinchHardware:0.1336,
    draftHardware:0.1596,
    draftDirectStandardIon:1.336,
    draftDirectWideArgon:1.478,
    sacks:Object.freeze({le15:0.61,le17:0.672,le19:0.638,le22:0.726,le25:0.843,le28:0.977,le32:1.1,gt32:1.33})
  }),
  summit:Object.freeze({
    draftEffectiveDepth:5.25,
    snapAssembly:0.02116666666666657,
    sackRate:0.0011669117647058822,
    shockCordWeightPerInch:0.125/29,
    cinchHardware:0.1336,
    draftHardware:0.1596,
    sacks:Object.freeze({le15:0.61,le22:0.75,le28:0.977})
  }),
  trailBird:Object.freeze({
    curveFactors:Object.freeze({ridge:1.621,sides:1.345,head:1.493,foot:1.401}),
    reinforcement:0.228,
    ridgelineTiePair:0.055,
    bivyLoopPair:0.02,
    ridgelineLoopEach:0.0075,
    assemblyTreatment:0.117,
    seamSealAnchor:0.032,
    seamSealChordAnchor:123.58397954427589,
    sackBase:0.3275,
    sackReferenceDensity:1.1230132757023774
  }),
  trailDuster2Hammock:Object.freeze({baseReinforcement:0.23,extraReinforcement:0.0245,ridgeAssemblyEach:0.08227272727272728}),
  trailHaven:Object.freeze({baseReinforcement:0.2218,extraMidpointReinforcement:0.0106,ridgeAssemblyPair:0.16454545454545455}),
  trailDuster2:Object.freeze({baseReinforcement:0.23,extraReinforcementBackpacking:0.049,bivyLoopPair:0.02,ridgelineLoopEach:0.0075}),
  originalTrailDuster:Object.freeze({hemThreadTreatment:0.041,sidePullCount:2,sidePullSeal:0.022}),
  trailLair:Object.freeze({
    mainSacks:Object.freeze({doubleOrWide:0.675,lightFive:0.55,lightThree:0.5,standard:0.6}),
    netSack:0.26
  }),
  treeRunner:Object.freeze({mainSacks:Object.freeze({wide:0.68,standard:0.6})}),
  streamliner:Object.freeze({mainSacks:Object.freeze({wide:0.68,standard:0.6})}),
  voyageur:Object.freeze({hoodFallbackArea:0.261,mainSack:0.675}),
  windHaven:Object.freeze({doorSnapCount:8}),
  winterHaven:Object.freeze({snapCounts:Object.freeze({standard:10,wide:12})})
});
const products=Object.freeze({
gearHammock:Object.freeze({"FIELD_LABELS":{"Fabric/Color * (required)":"Fabric","Continuous Loops * (required)":"Loops","Carabiners * (required)":"Carabiners","Suspension * (required)":"Suspension","Zipper Options * (required)":"Zipper","Storage Stuff Sack * (required)":"Sack"},"OPTIONS":{"Fabric":["Nylon Ripstop 1.4 oz - Charcoal Grey","Nylon Ripstop 1.6 oz - Green Tea","Nylon Ripstop 1.9 oz - Foliage Grey","Silnylon 1.1 - Dark Olive","Custom Color (Please Contact Me First)"],"Loops":["None","Lash-It (Non Spliced)","Removable Amsteel (Spliced)","Permanent Amsteel (Spliced)"],"Carabiners":["None","Mini Biners","Full Size Carabiners"],"Suspension":["None","20' Lash-It","6' Amsteel Whoopie Slings"],"Zipper":["No Zipper","#3 Zipper","#5 Waterproof Zipper"],"Sack":["No","Yes"]},"FABRIC_KEYS":{"Nylon Ripstop 1.4 oz - Charcoal Grey":"charcoal","Nylon Ripstop 1.6 oz - Green Tea":"greenTea","Nylon Ripstop 1.9 oz - Foliage Grey":"foliage","Silnylon 1.1 - Dark Olive":"darkOlive","Custom Color (Please Contact Me First)":"manual"}}),zipperedPouch:Object.freeze({"FIELD_LABELS":{"Fabric/Color * (required)":"Fabric","Pouch Orientation * (required)":"Orientation","Width * (required)":"Width","Height * (required)":"Height","Zipper Size * (required)":"Zipper"},"OPTIONS":{"Fabric":["Mesh No-See-Um Netting","Silnylon 1.1 - Dark Olive","Xenon Sil 1.1 - Blaze Orange","Xenon Sil 1.1 - Charcoal Grey","Xenon Sil 1.1 - Moroccan Blue","Silpoly 1.6 - Charcoal Grey","500D Cordura - Multicam","750D Cordura - Black","1000D Cordura - Black","1000D Cordura - Coyote","1000D Cordura - Camo Green","1000D Cordura - Multicam"],"Orientation":["Vertical (zipper going up and down)","Horizontal (zipper going side to side)"],"Width":["2\"","3\"","4\"","5\"","6\"","7\"","8\"","9\"","10\"","11\"","12\"","13\"","14\"","15\""],"Height":["3\"","4\"","5\"","6\"","7\"","8\"","9\"","10\"","11\"","12\"","13\"","14\"","15\""],"Zipper":["#3 YKK","#5 YKK"]},"FABRIC_KEYS":{"Mesh No-See-Um Netting":"mesh","Silnylon 1.1 - Dark Olive":"darkOlive","Xenon Sil 1.1 - Blaze Orange":"blaze","Xenon Sil 1.1 - Charcoal Grey":"charcoal","Xenon Sil 1.1 - Moroccan Blue":"moroccan","Silpoly 1.6 - Charcoal Grey":"silpoly","500D Cordura - Multicam":"cordura500Multicam","750D Cordura - Black":"cordura750Black","1000D Cordura - Black":"cordura1000Black","1000D Cordura - Coyote":"cordura1000Coyote","1000D Cordura - Camo Green":"cordura1000CamoGreen","1000D Cordura - Multicam":"cordura1000Multicam"}}),
  roundBottomSack:Object.freeze({"FIELD_LABELS":{"Fabric/Color * (required)":"Fabric","Width * (required)":"Width","Length * (required)":"Length","Daisy Chain Webbing * (required)":"Daisy","Bottom Handle * (required)":"Handle","Reinforced Bottom * (required)":"Bottom"},"WIDTHS":{"4\"":4,"5\"":5,"6\"":6,"7\"":7,"8\"":8,"9\"":9,"10\"":10,"11\"":11,"12\"":12},"LENGTHS":{"5\"":5,"6\"":6,"7\"":7,"8\"":8,"9\"":9,"10\"":10,"11\"":11,"12\"":12,"13\"":13,"14\"":14,"15\"":15,"16\"":16,"17\"":17,"18\"":18,"19\"":19,"20\"":20,"21\"":21,"22\"":22,"23\"":23,"24\"":24,"25\"":25,"26\"":26,"27\"":27,"28\"":28,"29\"":29,"30\"":30,"31\"":31,"32\"":32},"DAISY":{"No":false,"Yes":true},"HANDLE":{"No":false,"Yes":true},"BOTTOM":{"No":false,"Yes":true},FABRICS:Object.freeze({"Silnylon 1.1 - Dark Olive":shared.fabrics.tarp.darkOliveSilnylon,"Xenon Sil 1.1 - Blaze Orange":shared.fabrics.tarp.xenon11Ordered,"Xenon Sil 1.1 - Charcoal Grey":shared.fabrics.tarp.xenon11Charcoal,"Xenon Sil 1.1 - Coyote Brown":shared.fabrics.tarp.xenon11Coyote,"Xenon Sil 1.1 - Moroccan Blue":shared.fabrics.tarp.xenon11Moroccan,"Silpoly 1.6 - Charcoal Grey":shared.fabrics.tarp.silpoly16Charcoal,"Nylon Ripstop 1.9 oz (coated) - Woodland Camo":Object.freeze({planningDensity:productControls.roundBottomSack.woodlandDensity})})}),
  dualSkins:Object.freeze({
    FIELD_LABELS:Object.freeze({'Fabric/Color * (required)':'Fabric','Length * (required)':'Length','Width * (required)':'Width','Tapered * (required)':'Tapered','Ridgeline Tie Out Pockets * (required)':'Pockets'}),
    FABRICS:Object.freeze({'No-See-Um Netting':shared.netting.noSeeUm09,'Xenon Sil 1.1 - Charcoal Grey':shared.fabrics.tarp.xenon11Charcoal}),
    LENGTHS:Object.freeze({"9'":9,"10'":10,"11'":11,"12'":12,"13'":13}),
    WIDTHS:Object.freeze({'Standard':productControls.dualSkins.standardWidth,'Wide':productControls.dualSkins.wideWidth}),
    TAPERED:Object.freeze({'No':false,'Yes':true}),POCKETS:Object.freeze({'No':false,'Yes':true})
  }),
  singleSkin:Object.freeze({
    FIELD_LABELS:Object.freeze({'Fabric/Color * (required)':'Fabric','Length * (required)':'Length','Width * (required)':'Width','Tapered * (required)':'Tapered','Ridgeline Tie Out Pockets * (required)':'Pockets'}),
    FABRICS:Object.freeze({'No-See-Um Netting':shared.netting.noSeeUm09,'Xenon Sil 1.1 - Charcoal Grey':shared.fabrics.tarp.xenon11Charcoal}),
    LENGTHS:Object.freeze({"9'":9,"10'":10,"11'":11,"12'":12,"13'":13}),
    WIDTHS:Object.freeze({'Standard':productControls.singleSkin.standardWidth,'Wide':productControls.singleSkin.wideWidth}),
    TAPERED:Object.freeze({'No':false,'Yes':true}),POCKETS:Object.freeze({'No':false,'Yes':true})
  }),
  poleSack:Object.freeze({
    FIELD_LABELS:Object.freeze({'Fabric/Color * (required)':'Fabric','Width * (required)':'Width','Length * (required)':'Length','Reinforced Bottom * (required)':'Bottom','Daisy Chain Webbing * (required)':'Daisy'}),
    FABRICS:Object.freeze({
      'Silnylon 1.1 - Dark Olive':shared.fabrics.tarp.darkOliveSilnylon,
      'Xenon Sil 1.1 - Blaze Orange':shared.fabrics.tarp.xenon11Ordered,
      'Xenon Sil 1.1 - Charcoal Grey':shared.fabrics.tarp.xenon11Charcoal,
      'Xenon Sil 1.1 - Coyote Brown':shared.fabrics.tarp.xenon11Coyote,
      'Xenon Sil 1.1 - Moroccan Blue':shared.fabrics.tarp.xenon11Moroccan,
      'Silpoly 1.6 - Charcoal Grey':shared.fabrics.tarp.silpoly16Charcoal
    }),
    CUSTOM_FABRIC:'Custom (Please Contact Me First)',
    WIDTHS:Object.freeze({"2\"":2,"3\"":3,"4\"":4,"5\"":5,"6\"":6,"7\"":7,"8\"":8,"9\"":9,"10\"":10}),
    LENGTHS:Object.freeze({"12\"":12,"13\"":13,"14\"":14,"15\"":15,"16\"":16,"17\"":17,"18\"":18,"19\"":19,"20\"":20,"21\"":21,"22\"":22,"23\"":23,"24\"":24,"25\"":25,"26\"":26,"27\"":27,"28\"":28,"29\"":29,"30\"":30,"31\"":31,"32\"":32,"33\"":33,"34\"":34,"35\"":35,"36\"":36,"37\"":37,"38\"":38,"39\"":39,"40\"":40,"41\"":41,"42\"":42,"43\"":43,"44\"":44,"45\"":45,"46\"":46,"47\"":47,"48\"":48,"49\"":49,"50\"":50,"51\"":51,"52\"":52}),
    BOTTOM:Object.freeze({'No':false,'Yes':true}),
    DAISY:Object.freeze({'No':false,'Yes':true}),
    PROVISIONAL_FABRICS:Object.freeze({'Xenon Sil 1.1 - Blaze Orange':'Existing family planning density; not directly measured'})
  }),
  stakeSack:Object.freeze({
    FIELD_LABELS:Object.freeze({'Fabric/Color * (required)':'Fabric','Width * (required)':'Width','Length * (required)':'Length','Reinforced Bottom * (required)':'Bottom'}),
    FABRICS:Object.freeze({
      'Silnylon 1.1 - Dark Olive':shared.fabrics.tarp.darkOliveSilnylon,
      'Xenon Sil 1.1 - Blaze Orange':shared.fabrics.tarp.xenon11Ordered,
      'Xenon Sil 1.1 - Charcoal Grey':shared.fabrics.tarp.xenon11Charcoal,
      'Xenon Sil 1.1 - Coyote Brown':shared.fabrics.tarp.xenon11Coyote,
      'Xenon Sil 1.1 - Moroccan Blue':shared.fabrics.tarp.xenon11Moroccan,
      'Silpoly 1.6 - Charcoal Grey':shared.fabrics.tarp.silpoly16Charcoal
    }),
    CUSTOM_FABRIC:'Custom (Please Contact Me First)',
    WIDTHS:Object.freeze({'2"':2,'3"':3,'4"':4,'5"':5,'6"':6}),
    LENGTHS:Object.freeze({'6"':6,'7"':7,'8"':8,'9"':9,'10"':10,'11"':11,'12"':12,'13"':13,'14"':14}),
    BOTTOM:Object.freeze({'No':false,'Yes':true}),
    PROVISIONAL_FABRICS:Object.freeze({'Xenon Sil 1.1 - Blaze Orange':'Family planning fallback; no direct Blaze Orange measurement'})
  }),
  "catchAll": {
    "FABRICS": {
      "No-See-Um Netting": {
        "density": shared.netting.noSeeUm09.planningDensity,
        "waterproof": false
      },
      "Silnylon 1.1 - Dark Olive": {
        "density": shared.fabrics.tarp.darkOliveSilnylon.planningDensity,
        "waterproof": true
      },
      "Xenon Sil 1.1 - Charcoal Grey": {
        "density": shared.fabrics.tarp.xenon11Charcoal.planningDensity,
        "waterproof": true
      }
    },
    "LENGTHS": {
      "9'": productControls.catchAll.rawBodyLengthInches.ft9,
      "9.5'": productControls.catchAll.rawBodyLengthInches.ft9_5,
      "10'": productControls.catchAll.rawBodyLengthInches.ft10,
      "10.5'": productControls.catchAll.rawBodyLengthInches.ft10_5,
      "11'": productControls.catchAll.rawBodyLengthInches.ft11,
      "11.5'": productControls.catchAll.rawBodyLengthInches.ft11_5,
      "12'": productControls.catchAll.rawBodyLengthInches.ft12
    },
    "WIDTHS": {
      "Standard": "standard",
      "Wide": "wide"
    },
    "VENTED": {
      "No": false,
      "Yes": true
    },
    "POCKET": {
      "No": false,
      "Yes": true
    }
  },
  "eclipse": {
    "OUTSIDE_FABRICS": {
      "Ion - Black": {
        "density": shared.fabrics.quilt.ionBlack.planningDensity,
        "family": "Ion"
      },
      "Ion - Moroccan Blue": {
        "density": shared.fabrics.quilt.ionGeneric.planningDensity,
        "family": "Ion"
      },
      "Ion - (Choose from solid colors available at Dutchwaregear.com)": {
        "density": shared.fabrics.quilt.ionGeneric.planningDensity,
        "family": "Ion"
      },
      "Argon 90 - Black": {
        "density": shared.fabrics.quilt.argon90Black.planningDensity,
        "family": "Argon"
      },
      "Argon 90 - Charcoal Grey": {
        "density": shared.fabrics.quilt.argon90Charcoal.planningDensity,
        "family": "Argon"
      },
      "Argon 90 - Dark Olive": {
        "density": shared.fabrics.quilt.argon90Generic.planningDensity,
        "family": "Argon"
      },
      "Argon 90 - (Choose from solid colors available at Dutchwaregear.com)": {
        "density": shared.fabrics.quilt.argon90Generic.planningDensity,
        "family": "Argon"
      }
    },
    "INSIDE_FABRICS": {
      "Ion - Black": {
        "density": shared.fabrics.quilt.ionBlack.planningDensity,
        "family": "Ion"
      },
      "Ion - Moroccan Blue": {
        "density": shared.fabrics.quilt.ionGeneric.planningDensity,
        "family": "Ion"
      },
      "Ion - (Choose from solid colors available at Dutchwaregear.com)": {
        "density": shared.fabrics.quilt.ionGeneric.planningDensity,
        "family": "Ion"
      },
      "Argon 90 - Black": {
        "density": shared.fabrics.quilt.argon90Black.planningDensity,
        "family": "Argon"
      },
      "Argon 90 - Charcoal Grey": {
        "density": shared.fabrics.quilt.argon90Charcoal.planningDensity,
        "family": "Argon"
      },
      "Argon 90 - Dark Olive": {
        "density": shared.fabrics.quilt.argon90Generic.planningDensity,
        "family": "Argon"
      },
      "Argon 90 - (Choose from solid colors available at Dutchwaregear.com)": {
        "density": shared.fabrics.quilt.argon90Generic.planningDensity,
        "family": "Argon"
      },
      "Argon 67 - (Choose from solid colors available at Dutchwaregear.com)": {
        "density": shared.fabrics.quilt.argon67Generic.planningDensity,
        "family": "Argon"
      }
    },
    "LENGTHS": {
      "Short": {
        "upperStraight": 36,
        "taperVertical": 37
      },
      "Regular": {
        "upperStraight": 39,
        "taperVertical": 38.5
      },
      "Long": {
        "upperStraight": 42,
        "taperVertical": 40
      }
    },
    "WIDTHS": {
      "Standard": "standard",
      "Wide": "wide"
    },
    "FOOTBOXES": {
      "Small": {
        "lowerTaperWidth": 38,
        "footboxWidth": 10,
        "footboxVertical": 11
      },
      "Medium": {
        "lowerTaperWidth": 43,
        "footboxWidth": 11,
        "footboxVertical": 12.5
      },
      "Large": {
        "lowerTaperWidth": 49,
        "footboxWidth": 12,
        "footboxVertical": 14
      }
    },
    "INSULATION": {
      "Apex Climashield 2.5 (50°F)": shared.insulation.apex25.planningDensity,
      "Apex Climashield 3.6 (40°F)": shared.insulation.apex36.planningDensity,
      "Apex Climashield 5.0 (30°F)": shared.insulation.apex50.planningDensity,
      "Apex Climashield 6.0 (20°F)": shared.insulation.apex60.planningDensity
    },
    "COLLARS": {
      "None": "none",
      "Cinch Collar": "cinch",
      "Draft Collar": "draft"
    },
    "COMPRESSION_SACK": {
      "No": false,
      "Yes": true
    },
    "STANDARD_COMPONENTS": 0.076
  },
  "simplicity": {
    "FABRICS": {
      "Silnylon 1.1 - Dark Olive": {
        "usableWidth": shared.fabrics.tarp.darkOliveSilnylon.usableWidth,
        "sack": 0.26979166666666665,
        "density": shared.fabrics.tarp.darkOliveSilnylon.planningDensity
      },
      "Xenon Sil 1.1 - Charcoal Grey": {
        "density": shared.fabrics.tarp.xenon11Charcoal.planningDensity,
        "usableWidth": shared.fabrics.tarp.xenon11Charcoal.usableWidth,
        "sack": 0.26979166666666665
      },
      "Xenon Sil 1.1 - Coyote Brown": {
        "usableWidth": shared.fabrics.tarp.xenon11Coyote.usableWidth,
        "sack": 0.26979166666666665,
        "density": shared.fabrics.tarp.xenon11Coyote.planningDensity
      },
      "Xenon Sil 1.1 - Moroccan Blue": {
        "density": shared.fabrics.tarp.xenon11Moroccan.planningDensity,
        "usableWidth": shared.fabrics.tarp.xenon11Moroccan.usableWidth,
        "sack": 0.26979166666666665
      },
      "Xenon Sil 1.1 (Choose from colors available at Dutchwaregear.com)": {
        "sack": 0.26979166666666665,
        "density": shared.fabrics.tarp.xenon11Ordered.planningDensity,
        "usableWidth": shared.fabrics.tarp.xenon11Ordered.usableWidth
      },
      "Xenon Sil .9 (Choose from colors available at Dutchwaregear.com)": {
        "density": shared.fabrics.tarp.xenon09.planningDensity,
        "usableWidth": shared.fabrics.tarp.xenon09.usableWidth,
        "sack": 0.235
      },
      "Xenon Sil Wide (Choose from colors available at Dutchwaregear.com)": {
        "usableWidth": shared.fabrics.tarp.xenonWide.usableWidth,
        "sack": 0.2877777777777778,
        "density": shared.fabrics.tarp.xenonWide.planningDensity
      },
      "Silpoly 1.1 (Choose from available solid colors at Ripstopbytheroll.com)": {
        "usableWidth": shared.fabrics.tarp.silpoly11Generic.usableWidth,
        "sack": 0.26979166666666665,
        "density": shared.fabrics.tarp.silpoly11Generic.planningDensity
      },
      "Silpoly XL (Choose from available solid colors at Ripstopbytheroll.com)": {
        "usableWidth": shared.fabrics.tarp.silpolyXLGeneric.usableWidth,
        "sack": 0.2877777777777778,
        "density": shared.fabrics.tarp.silpolyXLGeneric.planningDensity
      }
    },
    "LENGTHS": {
      "Short": 118,
      "Standard": 130,
      "Long": 142
    },
    "GROUND_HARDWARE": {
      "Loops Only": 0.021,
      "Line Loc 3's": 0.109,
      "Line Lock V's": 0.103,
      "Line Lock Lites (10mm)": 0.093,
      "Line Lock Lites (15mm)": 0.097,
      "D-Rings": 0.039333
    },
    "STORM_MODE": {
      "No": 0,
      "Yes": 0.053333
    },
    "RIDGELINE_CORD": {
      "None (I will use my own)": shared.accessories.none,
      "25' of 1.75mm Zing-It": shared.accessories.zingIt25,
      "Pair of Dutch Tarp Flyz (No Cord)": shared.accessories.tarpFlyzPair,
      "Pair of Flyz spliced to (2) 12' Yellow Zing-It lines": shared.accessories.flyzSplicedZingItPair,
      "Pair of Flyz spliced to (2) 12' Grey Lash-It lines": shared.accessories.flyzSplicedLashItPair
    },
    "GLOWIRE": {
      "None (I will use my own)": shared.accessories.none,
      "10’ Lawson Equipment Glowire - Orange Reflective": 0.405,
      "20’ Lawson Equipment Glowire - Orange Reflective": 0.81
    },
    "STAKES": {
      "None (I will use my own)": 0,
      "(2) 7\" Aluminum Y-Stakes": 1.12025,
      "(2) 6.5\" UL Titanium Stakes": 0.68285
    },
    "PATCH_KIT": {
      "No": 0,
      "Yes": shared.accessories.patchKit
    },
    "CUTOUT_AREA": 1122.239231,
    "FIXED_SEWN_WEIGHT": 0.27799999999999997
  },
  "starter": {
    "LAYERS": {
          "Single": 1,
          "Double Without Pad Opening": 2,
          "Double With Pad Opening": 2
    },
    "LENGTHS": {
      "8' (great for kids)": 8,
      "9'": 9,
      "10'": 10,
      "11'": 11,
      "12'": 12
    },
    "FABRICS": {
      "Charcoal Grey 1.4 oz Nylon Ripstop": {
        "density": 1.4,
        "width": 62,
        "overhead": 0
      },
      "Foliage Grey XL 1.9 oz Nylon Ripstop": {
        "density": 1.8945661764705883,
        "width": 68,
        "overhead": 0.098
      },
      "Green Tea 1.6 oz Nylon Ripstop": {
        "density": 1.508983888292159,
        "width": 61.25,
        "overhead": 0
      },
      "Hexon Wide 1.7 - Burnt Orange": {
        "density": 1.7,
        "width": 73,
        "overhead": 0
      }
    },
    "RIDGELINES": {
      "Fixed (AmSteel)": shared.hammocks.ridgelines.fixedByLength,
      "Adjustable": shared.hammocks.ridgelines.adjustableByLength
    },
    "SUSPENSIONS": {
      "Whoopies/Straps/Toggles": {
        "weight": 4.8165,
        "sack": 0.191
      },
      "Whoopies/Straps/Carabiners": {
        "weight": 6.074,
        "sack": 0.191
      },
      "Cinch Buckle": {
        "weight": shared.suspension.cinchBuckleStarter.weight,
        "sack": shared.suspension.cinchBuckleStarter.sack
      }
    },
    "MAIN_SACKS": {
      "8": 0.6,
      "9": 0.6,
      "10": 0.6,
      "11": 0.75,
      "12": 0.75
    }
  },
  "streamliner": {
    "STANDARD_END_AREA": 145.58058925476604,
    "WIDE_END_AREA": 202.3570190641248,
    "FOLIAGE_END_AREA": 177.8560201194593,
    "SIDE_AREA_RATE": 6.219621470928925,
    "FABRICS": {
      "Hexon 1.6 - Charcoal Grey": {
        "density": shared.overrides.streamliner.fabrics.hexonGeneric.planningDensity,
        "width": shared.overrides.streamliner.fabrics.hexonGeneric.usableWidth,
        "endArea": 145.58058925476604
      },
      "Hexon 1.6 - Coyote Brown": {
        "density": shared.overrides.streamliner.fabrics.hexonGeneric.planningDensity,
        "endArea": 145.58058925476604,
        "width": shared.overrides.streamliner.fabrics.hexonGeneric.usableWidth
      },
      "Hexon 1.6 - Dark Olive": {
        "density": shared.overrides.streamliner.fabrics.hexonDarkOlive.planningDensity,
        "width": shared.overrides.streamliner.fabrics.hexonDarkOlive.usableWidth,
        "endArea": 145.58058925476604
      },
      "Hexon 1.6 - Moroccan Blue": {
        "density": shared.overrides.streamliner.fabrics.hexonMoroccan.planningDensity,
        "endArea": 145.58058925476604,
        "width": shared.overrides.streamliner.fabrics.hexonMoroccan.usableWidth
      },
      "Hexon 1.6 (Choose from colors available at Dutchwaregear.com)": {
        "density": shared.overrides.streamliner.fabrics.hexonGeneric.planningDensity,
        "width": shared.overrides.streamliner.fabrics.hexonGeneric.usableWidth,
        "endArea": 145.58058925476604
      },
      "Hexon Wide 1.6 - Dark Olive": {
        "density": shared.fabrics.hammock.hexonWide16DarkOlive.planningDensity,
        "endArea": 202.3570190641248,
        "width": 73
      },
      "Hexon Wide 1.6 (Choose from colors available at Dutchwaregear.com)": {
        "density": shared.fabrics.hammock.hexonWide16.planningDensity,
        "width": shared.fabrics.hammock.hexonWide16.usableWidth,
        "endArea": 202.3570190641248
      },
      "Foliage Grey XL 1.9 oz Nylon Ripstop": {
        "density": 1.8945661764705883,
        "width": 74,
        "endArea": 177.8560201194593
      },
      "HyperD 1.6 (Choose from colors available at Ripstopbytheroll.com)": {
        "density": 1.6,
        "width": 60,
        "endArea": 145.58058925476604
      },
      "MTN 1.7 XL (Choose from colors available at Ripstopbytheroll.com)": {
        "density": 1.6722,
        "width": 75,
        "endArea": 202.3570190641248
      },
      "2.2 oz Hex70 XL (Choose from colors available at Ripstopbytheroll.com)": {
        "endArea": 202.3570190641248,
        "density": 2.2,
        "width": 74
      }
    },
    "LENGTHS": {
      "8'": 8,
      "9'": 9,
      "10'": 10,
      "11'": 11,
      "12'": 12
    },
    "LAYERS": {
      "Single": 1,
      "Double Without Pad Opening": 2,
      "Double With Pad Opening": 2
    },
    "RIDGELINES": {
      "No, I will use my own": {
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0
      },
      "Yes": shared.hammocks.ridgelines.adjustableByLength
    },
    "SUSPENSIONS": {
      "None (I will use my own)": {
        "weight": shared.suspension.none.weight,
        "sack": shared.suspension.none.sack
      },
      "Cinch Buckle": {
        "weight": shared.suspension.cinchBuckleNonStarter.weight,
        "sack": shared.suspension.cinchBuckleNonStarter.sack
      },
      "Whoopies/Straps/Toggles": {
        "weight": shared.suspension.whoopieToggle.weight,
        "sack": shared.suspension.whoopieToggle.sack
      },
      "Whoopies/Straps/Carabiners (1 Blue, 1 Orange)": {
        "weight": shared.suspension.whoopieCarabiner.weight,
        "sack": shared.suspension.whoopieCarabiner.sack
      },
      "Whoopies/Straps/Dutch Whoopie Hooks": {
        "weight": shared.suspension.whoopieHook.weight,
        "sack": shared.suspension.whoopieHook.sack
      },
      "Dutch Beetle Buckles (w/12' Black Straps and sewn Dutch Clips)": {
        "weight": shared.suspension.beetleBuckle.weight,
        "sack": shared.suspension.beetleBuckle.sack
      }
    },
    "DELTAS": {
      "Knee & Shoulder Tie Outs": {
        "No": 0,
        "Webbing Loops": shared.hammockOptions.addOnTieLoops,
        "D-Rings": shared.hammockOptions.addOnTieDRings
      },
      "Continuous Loops": {
        "No": 0,
        "Yes": shared.hammocks.continuousLoops.permanent
      },
      "Peak Shelf": {
        "No": 0,
        "Yes, Head End Only": shared.hammockOptions.peakShelfOne,
        "Yes, Foot End Only": shared.hammockOptions.peakShelfOne,
        "Yes, Both Head & Foot Ends": shared.hammockOptions.peakShelfBoth
      },
      "Under Quilt Hooks": {
        "No": 0,
        "Yes, UQ Hooks only": shared.hammockOptions.uqHooks,
        "Yes, UQ Hooks + D-Rings": shared.hammockOptions.uqHooksDRings
      },
      "Zippered Shoulder Pouch": {
        "No": 0,
        "Yes, Left Head End": shared.hammockOptions.zipperedPouch,
        "Yes, Right Head End": shared.hammockOptions.zipperedPouch
      }
    },
    "SACKS": {
      "Standard Stuff Sack": 0,
      "Stuff Sack w/ Zippered Strap Pouch": shared.hammockOptions.zipperedStrapSack
    }
  },
  "summit": {
    "FABRICS": {
      "Ion - Black": {
        "family": "Ion",
        "density": shared.fabrics.quilt.ionBlack.planningDensity
      },
      "Ion - Moroccan Blue": {
        "family": "Ion",
        "density": shared.fabrics.quilt.ionGeneric.planningDensity
      },
      "Ion - (Choose from solid colors available at Dutchwaregear.com)": {
        "family": "Ion",
        "density": shared.fabrics.quilt.ionGeneric.planningDensity
      },
      "Argon 90 - Black": {
        "family": "Argon",
        "density": shared.fabrics.quilt.argon90Black.planningDensity
      },
      "Argon 90 - Charcoal Grey": {
        "family": "Argon",
        "density": shared.fabrics.quilt.argon90Charcoal.planningDensity
      },
      "Argon 90 - Dark Olive": {
        "density": shared.fabrics.quilt.argon90Generic.planningDensity,
        "family": "Argon"
      },
      "Argon 90 - (Choose from solid colors available at Dutchwaregear.com)": {
        "family": "Argon",
        "density": shared.fabrics.quilt.argon90Generic.planningDensity
      },
      "Argon 67 - (Choose from solid colors available at Dutchwaregear.com)": {
        "family": "Argon",
        "density": shared.fabrics.quilt.argon67Generic.planningDensity
      }
    },
    "INSULATION": {
      "Apex Climashield 2.5 (50°F)": shared.insulation.apex25.planningDensity,
      "Apex Climashield 3.6 (40°F)": shared.insulation.apex36.planningDensity,
      "Apex Climashield 5.0 (30°F)": shared.insulation.apex50.planningDensity,
      "Apex Climashield 6.0 (20°F)": shared.insulation.apex60.planningDensity
    },
    "LENGTHS": {
      "66\"": 66,
      "67\"": 67,
      "68\"": 68,
      "69\"": 69,
      "70\"": 70,
      "71\"": 71,
      "72\"": 72,
      "73\"": 73,
      "74\"": 74,
      "75\"": 75,
      "76\"": 76,
      "77\"": 77,
      "78\"": 78,
      "79\"": 79,
      "80\"": 80,
      "81\"": 81,
      "82\"": 82,
      "83\"": 83,
      "84\"": 84
    },
    "WIDTHS": {
      "42\"": 42,
      "43\"": 43,
      "44\"": 44,
      "45\"": 45,
      "46\"": 46,
      "47\"": 47,
      "48\"": 48,
      "49\"": 49,
      "50\"": 50,
      "51\"": 51,
      "52\"": 52,
      "53\"": 53,
      "54\"": 54,
      "55\"": 55,
      "56\"": 56,
      "57\"": 57,
      "58\" (Argon 67 or Ion only; not Argon 90)": 58
    },
    "LOOPS": {
      "No Loops": 0,
      "Loops at 4 Corners Only": 0.022,
      "Loops at 4 Corners and 3 Sets Spaced Evenly Down Sides": 0.055
    },
    "COLLARS": {
      "None": "none",
      "Cinch Collar": "cinch",
      "Insulated Draft Collar": "draft"
    },
    "FOOT_COLLARS": {
      "None": {
        "type": "none",
        "snapCount": 0.0
      },
      "Cinch Collar": {
        "type": "cinch",
        "snapCount": 0.0
      },
      "Cinch Collar w/ Footbox Snaps": {
        "type": "cinch",
        "snapCount": 12.0
      },
      "Draft Collar": {
        "type": "draft",
        "snapCount": 0.0
      },
      "Draft Collar w/ Footbox Snaps": {
        "type": "draft",
        "snapCount": 12.0
      }
    },
    "COMPRESSION_SACK": {
      "No": false,
      "Yes": true
    }
  },
  "trail_bird": {
    "FABRICS": {
      "Silnylon 1.1 - Dark Olive": {
        "usableWidth": shared.fabrics.tarp.darkOliveSilnylon.usableWidth,
        "density": shared.fabrics.tarp.darkOliveSilnylon.planningDensity
      },
      "Silnylon 1.1 (Choose from colors available at Dutchwaregear.com)": {
        "usableWidth": shared.fabrics.tarp.silnylon11Generic.usableWidth,
        "density": shared.fabrics.tarp.silnylon11Generic.planningDensity
      },
      "Xenon Sil 1.1 - Charcoal Grey": {
        "usableWidth": shared.fabrics.tarp.xenon11Charcoal.usableWidth,
        "density": shared.fabrics.tarp.xenon11Charcoal.planningDensity
      },
      "Xenon Sil 1.1 - Coyote Brown": {
        "usableWidth": shared.fabrics.tarp.xenon11Coyote.usableWidth,
        "density": shared.fabrics.tarp.xenon11Coyote.planningDensity
      },
      "Xenon Sil 1.1 - Moroccan Blue": {
        "usableWidth": shared.fabrics.tarp.xenon11Moroccan.usableWidth,
        "density": shared.fabrics.tarp.xenon11Moroccan.planningDensity
      },
      "Xenon Sil 1.1 (Choose from colors available at Dutchwaregear.com)": {
        "usableWidth": shared.fabrics.tarp.xenon11Ordered.usableWidth,
        "density": shared.fabrics.tarp.xenon11Ordered.planningDensity
      },
      "Silpoly 1.1 (Choose from available solid colors at Ripstopbytheroll.com)": {
        "density": shared.fabrics.tarp.silpoly11Generic.planningDensity,
        "usableWidth": shared.fabrics.tarp.silpoly11Generic.usableWidth
      },
      "Silpoly 1.6 (Choose from available solid colors at Ripstopbytheroll.com)": {
        "density": shared.fabrics.tarp.silpoly16Generic.planningDensity,
        "usableWidth": shared.fabrics.tarp.silpoly16Generic.usableWidth
      }
    },
    "LENGTHS": {
      "9'": 9,
      "10'": 10
    },
    "HEAD_WIDTHS": {
      "6'": 72,
      "7'": 84,
      "8'": 96,
      "9'": 108
    },
    "FOOT_WIDTHS": {
      "4'": 48,
      "5'": 60,
      "6'": 72,
      "7'": 84
    },
    "GROUND_HARDWARE": {
      "Loops Only": {
        "hardware": shared.components.groundHardware.loopOnly.weight,
        "grosgrain": shared.components.grosgrain.oneHalfPerInch
      },
      "Line Loc 3's": {
        "hardware": shared.components.groundHardware.lineLoc3.weight,
        "grosgrain": shared.components.grosgrain.oneHalfPerInch
      },
      "Line Lock V's": {
        "hardware": shared.components.groundHardware.lineLockV.weight,
        "grosgrain": shared.components.grosgrain.oneHalfPerInch
      },
      "Line Lock Lites (10mm)": {
        "hardware": shared.components.groundHardware.lineLockLite10.weight,
        "grosgrain": shared.components.grosgrain.threeEighthPerInch
      },
      "Line Lock Lites (15mm)": {
        "hardware": shared.components.groundHardware.lineLockLite15.weight,
        "grosgrain": shared.components.grosgrain.oneHalfPerInch
      },
      "D-Rings": {
        "hardware": shared.components.groundHardware.dRing.weight,
        "grosgrain": shared.components.grosgrain.oneHalfPerInch
      }
    },
    "RIDGELINE_LOOPS": {
      "None": 0,
      "One (Centered)": 1,
      "Two (Spaced at 1/3 and 2/3 length of tarp)": 2,
      "Three (Spaced at 1/4, 1/2 and 3/4 length of tarp)": 3
    },
    "BIVY_LOOPS": {
      "No": false,
      "Yes": true
    },
    "GLOWIRE": {
      "None (I will use my own)": shared.accessories.none,
      "25’ Lawson Equipment Glowire - Orange Reflective": shared.accessories.glowire25,
      "50’ Lawson Equipment Glowire - Orange Reflective": shared.accessories.glowire50
    },
    "STAKES": {
      "None (I will use my own)": 0,
      "(6) 7\" Aluminum Y-Stakes": 2.885,
      "(6) 6.5\" UL Titanium Stakes": 1.5729999998
    },
    "PATCH_KIT": {
      "No": 0,
      "Yes": shared.accessories.patchKit
    }
  },
  "trail_duster_2_hammock": {
    "FABRICS": {
      "Silnylon 1.1 - Dark Olive": {
        "className": "standard",
        "density": shared.fabrics.tarp.darkOliveSilnylon.planningDensity
      },
      "Silnylon 1.1 (Choose from colors available at Dutchwaregear.com)": {
        "className": "standard",
        "density": shared.fabrics.tarp.silnylon11Generic.planningDensity
      },
      "Xenon Sil 1.1 - Charcoal Grey": {
        "className": "standard",
        "density": shared.fabrics.tarp.xenon11Charcoal.planningDensity
      },
      "Xenon Sil 1.1 - Coyote Brown": {
        "className": "standard",
        "density": shared.fabrics.tarp.xenon11Coyote.planningDensity
      },
      "Xenon Sil 1.1 - Moroccan Blue": {
        "className": "standard",
        "density": shared.fabrics.tarp.xenon11Moroccan.planningDensity
      },
      "Xenon Sil 1.1 (Choose from colors available at Dutchwaregear.com)": {
        "className": "standard",
        "density": shared.fabrics.tarp.xenon11Ordered.planningDensity
      },
      "Xenon Sil Wide (Choose from colors available at Dutchwaregear.com)": {
        "maximumWidth": 136,
        "density": shared.fabrics.tarp.xenonWide.planningDensity,
        "className": "wide"
      },
      "Silpoly 1.1 (Choose from available solid colors at Ripstopbytheroll.com)": {
        "className": "standard",
        "density": shared.fabrics.tarp.silpoly11Generic.planningDensity
      },
      "Silpoly 1.6 (Choose from available solid colors at Ripstopbytheroll.com)": {
        "density": shared.fabrics.tarp.silpoly16Generic.planningDensity,
        "className": "standard"
      },
      "Silpoly XL (Choose from available solid colors at Ripstopbytheroll.com)": {
        "maximumWidth": 138,
        "density": shared.fabrics.tarp.silpolyXLGeneric.planningDensity,
        "className": "wide"
      }
    },
    "LENGTHS": {
      "10'": 10,
      "11'": 11,
      "12'": 12,
      "13'": 13
    },
    "WIDTHS": {
      "84\"": 84,
      "96\"": 96,
      "108\"": 108,
      "112\" (Max width of standard fabrics)": 112,
      "120\" (Only available in Silpoly XL or Xenon Sil Wide)": 120,
      "132\" (Only available in Silpoly XL or Xenon Sil Wide)": 132
    },
    "MAXIMUM_WIDTH": "Max Width (136\" for Xenon Sil Wide and 138” for Silpoly XL)",
    "EDGES": {
      "Straight": {
        "extraTieOuts": false,
        "catenary": false
      },
      "Catenary Cut": {
        "extraTieOuts": false,
        "catenary": true
      },
      "Straight w/ Extra Perimeter Tie Outs": {
        "catenary": false,
        "extraTieOuts": true
      }
    },
    "GROUND_HARDWARE": {
      "Loops Only": {
        "corner": shared.tarps.groundAssemblies.loopOnly.corner,
        "side": shared.tarps.groundAssemblies.loopOnly.side
      },
      "Line Loc 3's": {
        "corner": shared.tarps.groundAssemblies.lineLoc3.corner,
        "side": shared.tarps.groundAssemblies.lineLoc3.side
      },
      "Line Lock V's": {
        "corner": shared.tarps.groundAssemblies.lineLockV.corner,
        "side": shared.tarps.groundAssemblies.lineLockV.side
      },
      "Line Lock Lites (10mm)": {
        "corner": shared.tarps.groundAssemblies.lineLockLite10.corner,
        "side": shared.tarps.groundAssemblies.lineLockLite10.side
      },
      "Line Lock Lites (15mm)": {
        "corner": shared.tarps.groundAssemblies.lineLockLite15.corner,
        "side": shared.tarps.groundAssemblies.lineLockLite15.side
      },
      "D-Rings": {
        "corner": shared.tarps.groundAssemblies.dRing.corner,
        "side": shared.tarps.groundAssemblies.dRing.side
      }
    },
    "SIDE_PULLS": {
      "None": false,
      "Yes": true,
      "Yes, Bridge Hammock Spacing (78\")": true,
      "Standard Spacing — D-Rings": true,
      "Standard Spacing — Webbing Loops": "webbingLoops",
      "Bridge Hammock Spacing — D-Rings": true,
      "Bridge Hammock Spacing — Webbing Loops": "webbingLoops"
    },
    "INTERNAL_RIDGELINE": {
      "No": false,
      "Yes (not needed if you add the pole set)": true
    },
    "GLOWIRE": {
      "None (I will use my own)": shared.accessories.none,
      "25’ Lawson Equipment Glowire - Orange Reflective": shared.accessories.glowire25,
      "50’ Lawson Equipment Glowire - Orange Reflective": shared.accessories.glowire50
    },
    "RIDGELINE_CORD": {
      "None (I will use my own)": shared.accessories.none,
      "25' of 1.75mm Zing-It": shared.accessories.zingIt25,
      "Pair of Dutch Tarp Flyz (No Cord)": shared.accessories.tarpFlyzPair,
      "Pair of Flyz Spliced to (2) 12' Yellow Zing-It lines": shared.accessories.flyzSplicedZingItPair,
      "Pair of Flyz spliced to (2) 12' Grey Lash-It lines": shared.accessories.flyzSplicedLashItPair
    },
    "POLES": {
      "No": 0,
      "Single Pole": 1,
      "Double Pole": 2,
      "Triple Pole": 3
    },
    "STAKES": {
      "None (I will use my own)": 0,
      "(6) 7\" Aluminum Y-Stakes": 2.885,
      "(6) 6.5\" UL Titanium Stakes": 1.5729999998
    },
    "PATCH_KIT": {
      "No": 0,
      "Yes": shared.accessories.patchKit
    }
  },
  "trail_duster_2": {
    "FABRICS": {
      "Silnylon 1.1 - Dark Olive": {
        "className": "standard",
        "density": shared.fabrics.tarp.darkOliveSilnylon.planningDensity
      },
      "Silnylon 1.1 (Choose from colors available at Dutchwaregear.com)": {
        "className": "standard",
        "density": shared.fabrics.tarp.silnylon11Generic.planningDensity
      },
      "Xenon Sil 1.1 - Charcoal Grey": {
        "className": "standard",
        "density": shared.fabrics.tarp.xenon11Charcoal.planningDensity
      },
      "Xenon Sil 1.1 - Coyote Brown": {
        "className": "standard",
        "density": shared.fabrics.tarp.xenon11Coyote.planningDensity
      },
      "Xenon Sil 1.1 - Moroccan Blue": {
        "className": "standard",
        "density": shared.fabrics.tarp.xenon11Moroccan.planningDensity
      },
      "Xenon Sil 1.1 (Choose from colors available at Dutchwaregear.com)": {
        "className": "standard",
        "density": shared.fabrics.tarp.xenon11Ordered.planningDensity
      },
      "Xenon Sil Wide (Choose from colors available at Dutchwaregear.com)": {
        "maximumWidth": 136,
        "density": shared.fabrics.tarp.xenonWide.planningDensity,
        "className": "wide"
      },
      "Silpoly 1.1 (Choose from available solid colors at Ripstopbytheroll.com)": {
        "className": "standard",
        "density": shared.fabrics.tarp.silpoly11Generic.planningDensity
      },
      "Silpoly 1.6 (Choose from available solid colors at Ripstopbytheroll.com)": {
        "density": shared.fabrics.tarp.silpoly16Generic.planningDensity,
        "className": "standard"
      },
      "Silpoly XL (Choose from available solid colors at Ripstopbytheroll.com)": {
        "maximumWidth": 138,
        "density": shared.fabrics.tarp.silpolyXLGeneric.planningDensity,
        "className": "wide"
      }
    },
    "LENGTHS": {
      "9'": 9,
      "10'": 10,
      "11'": 11,
      "12'": 12
    },
    "WIDTHS": {
      "84\"": 84,
      "96\"": 96,
      "108\"": 108,
      "112\" (max width of standard fabrics)": 112,
      "120\" (Only available in Silpoly XL or Xenon Sil Wide)": 120,
      "132\" (Only available in Silpoly XL or Xenon Sil Wide)": 132
    },
    "MAXIMUM_WIDTH": "Max Width (136\" for Xenon Sil Wide and 138” for Silpoly XL)",
    "EDGES": {
      "Straight": {
        "extraTieOuts": false,
        "catenary": false
      },
      "Catenary Cut": {
        "extraTieOuts": false,
        "catenary": true
      },
      "Straight w/ Extra Perimeter Tie Outs": {
        "catenary": false,
        "extraTieOuts": true
      }
    },
    "RIDGELINE_LOOPS": {
      "None": 0,
      "One (Centered)": 1,
      "Two (Spaced at 1/3 and 2/3 length of tarp)": 2,
      "Three (Spaced at 1/4, 1/2 and 3/4 length of tarp)": 3
    },
    "YES_NO": {
      "None": false,
      "No": false,
      "Yes": true
    },
    "SIDE_PULLS": {
      "None": false,
      "Yes — D-Rings": true,
      "Yes — Webbing Loops": "webbingLoops"
    },
    "GROUND_HARDWARE": {
      "Loops Only": shared.tarps.groundAssemblies.loopOnly,
      "Line Loc 3's": shared.tarps.groundAssemblies.lineLoc3,
      "Line Lock V's": shared.tarps.groundAssemblies.lineLockV,
      "Line Lock Lites (10mm)": shared.tarps.groundAssemblies.lineLockLite10,
      "Line Lock Lites (15mm)": shared.tarps.groundAssemblies.lineLockLite15,
      "D-Rings": shared.tarps.groundAssemblies.dRing
    },
    "GLOWIRE": {
      "None (I will use my own)": shared.accessories.none,
      "25’ Lawson Equipment Glowire - Orange Reflective": shared.accessories.glowire25,
      "50’ Lawson Equipment Glowire - Orange Reflective": shared.accessories.glowire50
    },
    "STAKES": {
      "None (I will use my own)": 0,
      "(8) 7\" Aluminum Y-Stakes": 3.789,
      "(8) 6.5\" UL Titanium Stakes": 2.0394
    },
    "PATCH_KIT": {
      "No": 0,
      "Yes": shared.accessories.patchKit
    }
  },
  "trail_duster": {
    "FABRICS": {
      "Silnylon 1.1 - Dark Olive": {
        "width": shared.fabrics.tarp.darkOliveSilnylon.usableWidth,
        "sack": 0.2877777778,
        "density": shared.fabrics.tarp.darkOliveSilnylon.planningDensity
      },
      "Silnylon 1.1 (Choose from colors available at Dutchwaregear.com)": {
        "width": shared.fabrics.tarp.silnylon11Generic.usableWidth,
        "sack": 0.2877777778,
        "density": shared.fabrics.tarp.silnylon11Generic.planningDensity
      },
      "Xenon Sil 1.1 - Charcoal Grey": {
        "width": shared.fabrics.tarp.xenon11Charcoal.usableWidth,
        "sack": 0.2877777778,
        "density": shared.fabrics.tarp.xenon11Charcoal.planningDensity
      },
      "Xenon Sil 1.1 - Coyote Brown": {
        "width": shared.fabrics.tarp.xenon11Coyote.usableWidth,
        "sack": 0.2877777778,
        "density": shared.fabrics.tarp.xenon11Coyote.planningDensity
      },
      "Xenon Sil 1.1 - Moroccan Blue": {
        "width": shared.fabrics.tarp.xenon11Moroccan.usableWidth,
        "sack": 0.2877777778,
        "density": shared.fabrics.tarp.xenon11Moroccan.planningDensity
      },
      "Xenon Sil 1.1 (Choose from colors available at Dutchwaregear.com)": {
        "width": shared.fabrics.tarp.xenon11Ordered.usableWidth,
        "sack": 0.2877777778,
        "density": shared.fabrics.tarp.xenon11Ordered.planningDensity
      },
      "Xenon Sil Wide (Choose from colors available at Dutchwaregear.com)": {
        "width": shared.fabrics.tarp.xenonWide.usableWidth,
        "sack": 0.2877777778,
        "density": shared.fabrics.tarp.xenonWide.planningDensity
      },
      "Silpoly 1.1 (Choose from available solid colors at Ripstopbytheroll.com)": {
        "width": shared.fabrics.tarp.silpoly11Generic.usableWidth,
        "sack": 0.2877777778,
        "density": shared.fabrics.tarp.silpoly11Generic.planningDensity
      },
      "Silpoly 1.6 (Choose from available solid colors at Ripstopbytheroll.com)": {
        "density": shared.fabrics.tarp.silpoly16Generic.planningDensity,
        "width": shared.fabrics.tarp.silpoly16Generic.usableWidth,
        "sack": 0.2877777778
      },
      "Silpoly XL (Choose from available solid colors at Ripstopbytheroll.com)": {
        "width": shared.fabrics.tarp.silpolyXLGeneric.usableWidth,
        "sack": shared.sacks.originalTrailDusterSilpolyXL,
        "density": shared.fabrics.tarp.silpolyXLGeneric.planningDensity
      }
    },
    "EXTRA_TIES": {
      "No": {
        "count": 8,
        "reinforcement": 0.1572
      },
      "Yes": {
        "count": 12,
        "reinforcement": 0.1784
      }
    },
    "HARDWARE": {
      "Loops Only": {
        "each": shared.components.groundHardware.loopOnly.weight,
        "webbing": shared.components.grosgrain.oneHalfPerInch
      },
      "Line Loc 3's": {
        "each": shared.components.groundHardware.lineLoc3.weight,
        "webbing": shared.components.grosgrain.oneHalfPerInch
      },
      "Line Lock V's": {
        "each": shared.components.groundHardware.lineLockV.weight,
        "webbing": shared.components.grosgrain.oneHalfPerInch
      },
      "Line Lock Lites (10mm)": {
        "each": shared.components.groundHardware.lineLockLite10.weight,
        "webbing": shared.components.grosgrain.threeEighthPerInch
      },
      "Line Lock Lites (15mm)": {
        "each": shared.components.groundHardware.lineLockLite15.weight,
        "webbing": shared.components.grosgrain.oneHalfPerInch
      },
      "D-Rings": {
        "each": shared.components.groundHardware.dRing.weight,
        "webbing": shared.components.grosgrain.oneHalfPerInch
      }
    },
    "SIDE_PULLS": {
      "None": 0,
      "Yes — D-Rings": 0.322,
      "Yes — Webbing Loops": productControls.originalTrailDuster.sidePullCount * shared.tarps.sidePulls.webbingLoopEach + productControls.originalTrailDuster.sidePullSeal
    },
    "GLOWIRE": {
      "None (I will use my own)": shared.accessories.none,
      "25’ Lawson Equipment Glowire - Orange Reflective": shared.accessories.glowire25,
      "50’ Lawson Equipment Glowire - Orange Reflective": shared.accessories.glowire50
    },
    "STAKES": {
      "None (I will use my own)": 0,
      "(5) 7\" Aluminum Y-Stakes": 2.433,
      "(5) 6.5\" UL Titanium Stakes": 1.3396666666666666
    },
    "PATCH_KITS": {
      "No": 0,
      "Yes": shared.accessories.patchKit
    }
  },
  "trail_haven": {
    "FABRICS": {
      "Silnylon 1.1 - Dark Olive": {
        "usableWidth": shared.fabrics.tarp.darkOliveSilnylon.usableWidth,
        "className": "standard",
        "density": shared.fabrics.tarp.darkOliveSilnylon.planningDensity
      },
      "Silnylon 1.1 (Choose from colors available at Dutchwaregear.com)": {
        "usableWidth": shared.fabrics.tarp.silnylon11Generic.usableWidth,
        "className": "standard",
        "density": shared.fabrics.tarp.silnylon11Generic.planningDensity
      },
      "Xenon Sil 1.1 - Charcoal Grey": {
        "usableWidth": shared.fabrics.tarp.xenon11Charcoal.usableWidth,
        "className": "standard",
        "density": shared.fabrics.tarp.xenon11Charcoal.planningDensity
      },
      "Xenon Sil 1.1 - Coyote Brown": {
        "usableWidth": shared.fabrics.tarp.xenon11Coyote.usableWidth,
        "className": "standard",
        "density": shared.fabrics.tarp.xenon11Coyote.planningDensity
      },
      "Xenon Sil 1.1 - Moroccan Blue": {
        "usableWidth": shared.fabrics.tarp.xenon11Moroccan.usableWidth,
        "className": "standard",
        "density": shared.fabrics.tarp.xenon11Moroccan.planningDensity
      },
      "Xenon Sil 1.1 (Choose from colors available at Dutchwaregear.com)": {
        "usableWidth": shared.fabrics.tarp.xenon11Ordered.usableWidth,
        "className": "standard",
        "density": shared.fabrics.tarp.xenon11Ordered.planningDensity
      },
      "Xenon Sil Wide (Choose from colors available at Dutchwaregear.com)": {
        "usableWidth": shared.fabrics.tarp.xenonWide.usableWidth,
        "className": "wide",
        "maximumWidth": 136,
        "density": shared.fabrics.tarp.xenonWide.planningDensity
      },
      "Silpoly 1.1 (Choose from available solid colors at Ripstopbytheroll.com)": {
        "usableWidth": shared.fabrics.tarp.silpoly11Generic.usableWidth,
        "className": "standard",
        "density": shared.fabrics.tarp.silpoly11Generic.planningDensity
      },
      "Silpoly 1.6 (Choose from available solid colors at Ripstopbytheroll.com)": {
        "density": shared.fabrics.tarp.silpoly16Generic.planningDensity,
        "className": "standard",
        "usableWidth": shared.fabrics.tarp.silpoly16Generic.usableWidth
      },
      "Silpoly XL (Choose from available solid colors at Ripstopbytheroll.com)": {
        "usableWidth": shared.fabrics.tarp.silpolyXLGeneric.usableWidth,
        "maximumWidth": 138,
        "density": shared.fabrics.tarp.silpolyXLGeneric.planningDensity,
        "className": "wide"
      }
    },
    "LENGTHS": {
      "10'": 10,
      "11'": 11,
      "12'": 12,
      "13'": 13
    },
    "WIDTHS": {
      "84\"": 84,
      "96\"": 96,
      "108\"": 108,
      "112\" (max width of standard fabrics)": 112,
      "120\" (Only available in Silpoly XL or Xenon Sil Wide)": 120,
      "132\" (Only available in Silpoly XL or Xenon Sil Wide)": 132
    },
    "MAXIMUM_WIDTH": "Max Width (136\" for Xenon Sil Wide and 138” for Silpoly XL)",
    "EDGES": {
      "Straight": {
        "extraMidpoints": false,
        "catenary": false
      },
      "Catenary Cut": {
        "extraMidpoints": false,
        "catenary": true
      },
      "Straight w/ Extra Perimeter Tie Out": {
        "catenary": false,
        "extraMidpoints": true
      }
    },
    "GROUND_HARDWARE": {
      "Loops Only": {
        "corner": shared.tarps.groundAssemblies.loopOnly.corner,
        "midpoint": shared.tarps.groundAssemblies.loopOnly.side
      },
      "Line Loc 3's": {
        "corner": shared.tarps.groundAssemblies.lineLoc3.corner,
        "midpoint": shared.tarps.groundAssemblies.lineLoc3.side
      },
      "Line Lock V's": {
        "corner": shared.overrides.trailHaven.lineLockVCorner,
        "midpoint": shared.tarps.groundAssemblies.lineLockV.side
      },
      "Line Lock Lites (10mm)": {
        "corner": shared.tarps.groundAssemblies.lineLockLite10.corner,
        "midpoint": shared.tarps.groundAssemblies.lineLockLite10.side
      },
      "Line Lock Lites (15mm)": {
        "corner": shared.tarps.groundAssemblies.lineLockLite15.corner,
        "midpoint": shared.tarps.groundAssemblies.lineLockLite15.side
      },
      "D-Rings": {
        "corner": shared.tarps.groundAssemblies.dRing.corner,
        "midpoint": shared.overrides.trailHaven.dRingMidpoint
      }
    },
    "SIDE_PULLS": {
      "None": false,
      "Yes": true,
      "Yes, Bridge Hammock Spacing (78\")": true,
      "Standard Spacing — D-Rings": true,
      "Standard Spacing — Webbing Loops": "webbingLoops",
      "Bridge Hammock Spacing — D-Rings": true,
      "Bridge Hammock Spacing — Webbing Loops": "webbingLoops"
    },
    "INTERNAL_RIDGELINE": {
      "No": false,
      "Yes (not needed if you add the pole set)": true
    },
    "RIDGELINE_CORD": {
      "None (I will use my own)": shared.accessories.none,
      "25' of 1.75mm Zing-It": shared.accessories.zingIt25,
      "Pair of Dutch Tarp Flyz (No Cord)": shared.accessories.tarpFlyzPair,
      "Pair of Flyz spliced to (2) 12' Yellow Zing-It lines": shared.accessories.flyzSplicedZingItPair,
      "Pair of Flyz spliced to (2) 12' Grey Lash-It lines": shared.accessories.flyzSplicedLashItPair
    },
    "GLOWIRE": {
      "None (I will use my own)": shared.accessories.none,
      "25’ Lawson Equipment Glowire - Orange Reflective": shared.accessories.glowire25,
      "50’ Lawson Equipment Glowire - Orange Reflective": shared.accessories.glowire50
    },
    "POLES": {
      "No": 0,
      "Single Pole": 1,
      "Double Pole": 2
    },
    "STAKES": {
      "None (I will use my own)": 0,
      "(4) 7\" Aluminum Y-Stakes": 1.981,
      "(4) 6.5\" UL Titanium Stakes": 1.1063333333333332
    },
    "PATCH_KIT": {
      "No": 0,
      "Yes": shared.accessories.patchKit
    }
  },
  "trail_lair": {
    "FABRICS": {
      "Hexon 1.6 - Charcoal Grey": {
        "density": shared.fabrics.hammock.hexon16.planningDensity,
        "width": shared.fabrics.hammock.hexon16.usableWidth
      },
      "Hexon 1.6 - Coyote Brown": {
        "density": shared.fabrics.hammock.hexon16.planningDensity,
        "width": shared.fabrics.hammock.hexon16.usableWidth
      },
      "Hexon 1.6 - Dark Olive": {
        "density": shared.fabrics.hammock.hexon16DarkOlive.planningDensity,
        "width": shared.fabrics.hammock.hexon16DarkOlive.usableWidth
      },
      "Hexon 1.6 - Moroccan Blue": {
        "density": shared.fabrics.hammock.hexon16Moroccan.planningDensity,
        "width": shared.fabrics.hammock.hexon16Moroccan.usableWidth
      },
      "Hexon 1.6 (Choose from colors available at Dutchwaregear.com)": {
        "density": shared.fabrics.hammock.hexon16.planningDensity,
        "width": shared.fabrics.hammock.hexon16.usableWidth
      },
      "Hexon 1.2 (Choose from colors available at Dutchwaregear.com)": {
        "lightSack": true,
        "density": shared.fabrics.hammock.hexon12.planningDensity,
        "width": shared.fabrics.hammock.hexon12.usableWidth
      },
      "Hexon Wide 1.6 - Dark Olive": {
        "density": shared.fabrics.hammock.hexonWide16DarkOlive.planningDensity,
        "wide": true,
        "width": shared.fabrics.hammock.hexonWide16DarkOlive.usableWidth
      },
      "Hexon Wide 1.6 (Choose from colors available at Dutchwaregear.com)": {
        "wide": true,
        "density": shared.fabrics.hammock.hexonWide16.planningDensity,
        "width": shared.fabrics.hammock.hexonWide16.usableWidth
      },
      "HyperD 1.6 (Choose from colors available at Ripstopbytheroll.com)": {
        "density": shared.fabrics.hammock.hyperD16.planningDensity,
        "width": shared.fabrics.hammock.hyperD16.usableWidth
      },
      "Monolite 1.0 (Choose from colors available at Ripstopbytheroll.com)": {
        "wide": true,
        "density": shared.fabrics.hammock.monolite10.planningDensity,
        "width": shared.fabrics.hammock.monolite10.usableWidth
      },
      "MTN 1.2 XL (Choose from colors available at Ripstopbytheroll.com)": {
        "wide": true,
        "lightSack": true,
        "density": shared.fabrics.hammock.mtn12XL.planningDensity,
        "width": shared.fabrics.hammock.mtn12XL.usableWidth
      },
      "MTN 1.7 XL (Choose from colors available at Ripstopbytheroll.com)": {
        "wide": true,
        "density": shared.fabrics.hammock.mtn17XL.planningDensity,
        "width": shared.fabrics.hammock.mtn17XL.usableWidth
      },
      "2.2 oz Hex70 XL (Choose from colors available at Ripstopbytheroll.com)": {
        "wide": true,
        "density": shared.fabrics.hammock.hex70XL.planningDensity,
        "width": shared.fabrics.hammock.hex70XL.usableWidth
      }
    },
    "LENGTHS": {
      "9'": {
        "netLength": 86,
        "tapeLength": 216,
        "amsteel": 0.47675,
        "lightRidgeline": 0.1644
      },
      "10'": {
        "netLength": 96,
        "tapeLength": 236,
        "amsteel": 0.51675,
        "lightRidgeline": 0.1737
      },
      "11'": {
        "netLength": 106,
        "tapeLength": 256,
        "amsteel": 0.55675,
        "lightRidgeline": 0.183
      },
      "12'": {
        "netLength": 116,
        "tapeLength": 276,
        "amsteel": 0.59675,
        "lightRidgeline": 0.1923
      }
    },
    "LAYERS": {
      "Single": 1,
      "Double Without Pad Opening": 2,
      "Double With Pad Opening": 2
    },
    "NETTINGS": {
      "No-See-Um (.9 oz)": {
        "base": 5.944,
        "baseline": 116,
        "width": 54.75,
        "density": 0.88
      },
      "Nano-See-Um (.7 oz)": {
        // Preserve old assembled-net anchor; replace only its modeled net fabric portion.
        "base": shared.netting.nano.referenceBase + (((shared.netting.nano.baseline-27)*shared.netting.nano.usableWidth-9)*shared.netting.nano.planningDensity-((shared.netting.nano.baseline-27)*shared.netting.nano.referenceWidth-9)*shared.netting.nano.referenceDensity)/1296,
        "baseline": shared.netting.nano.baseline,
        "width": shared.netting.nano.usableWidth,
        "density": shared.netting.nano.planningDensity
      }
    },
    "ZIPPERS": {
      "#3 YKK w/ black pulls": {
        "zipper": 0.43075,
        "tapeAdjustment": 0
      },
      "#3 YKK w/ silver pulls": {
        "zipper": 0.43075,
        "tapeAdjustment": 0
      },
      "#5 YKK w/ silver pulls": {
        "zipper": 1.06448,
        "tapeAdjustment": 0.008580769999999998
      }
    },
    "RIDGELINES": {
      "AmSteel (black)": "amsteel",
      "Zing-It (yellow)": "lightRidgeline",
      "Lash-It (grey)": "lightRidgeline"
    },
    "CONTINUOUS_LOOPS": {
      "Permanent (crafted into end channels)": shared.hammocks.continuousLoops.permanent,
      "Removable (larksheaded through end channels)": shared.hammocks.continuousLoops.removable
    },
    "SUSPENSIONS": {
      "None (I will use my own)": {
        "includesLoops": shared.suspension.none.includesLoops,
        "weight": shared.suspension.none.weight,
        "sack": shared.suspension.none.sack
      },
      "Cinch Buckle": {
        "includesLoops": shared.suspension.cinchBuckleNonStarter.includesLoops,
        "weight": shared.suspension.cinchBuckleNonStarter.weight,
        "sack": shared.suspension.cinchBuckleNonStarter.sack
      },
      "Whoopies/Straps/Toggles": {
        "includesLoops": shared.suspension.whoopieToggle.includesLoops,
        "weight": shared.suspension.whoopieToggle.weight,
        "sack": shared.suspension.whoopieToggle.sack
      },
      "Whoopies/Straps/Carabiners (1 Blue, 1 Orange)": {
        "includesLoops": shared.suspension.whoopieCarabiner.includesLoops,
        "weight": shared.suspension.whoopieCarabiner.weight,
        "sack": shared.suspension.whoopieCarabiner.sack
      },
      "Whoopies/Straps/Dutch Whoopie Hooks": {
        "includesLoops": shared.suspension.whoopieHook.includesLoops,
        "weight": shared.suspension.whoopieHook.weight,
        "sack": shared.suspension.whoopieHook.sack
      },
      "Dutch Beetle Buckles (w/12' Black Straps and sewn Dutch Clips)": {
        "includesLoops": shared.suspension.beetleBuckle.includesLoops,
        "weight": shared.suspension.beetleBuckle.weight,
        "sack": shared.suspension.beetleBuckle.sack
      }
    },
    "DELTAS": {
      "Knee & Shoulder Tie Outs": {
        "No": 0,
        "Webbing Loops": shared.hammockOptions.addOnTieLoops,
        "D-Rings": shared.hammockOptions.addOnTieDRings
      },
      "Under Quilt Hooks": {
        "No": 0,
        "Yes, UQ Hooks only": shared.hammockOptions.uqHooks,
        "Yes, UQ Hooks + D-Rings": shared.hammockOptions.uqHooksDRings
      },
      "Peak Shelf": {
        "No": 0,
        "Yes, Head End Only": shared.hammockOptions.peakShelfOne,
        "Yes, Foot End Only": shared.hammockOptions.peakShelfOne,
        "Yes, Both Head & Foot Ends": shared.hammockOptions.peakShelfBoth
      },
      "Bivy Mode Tie Outs": {
        "No": 0,
        "Yes": 0.058
      },
      "Ridgeline Gear Pouch": {
        "No": 0,
        "Yes": shared.hammockOptions.smallRidgelinePouch
      },
      "Zippered Storage Pouch": {
        "No": 0,
        "Yes, Left Head End": shared.hammockOptions.zipperedPouch,
        "Yes, Right Head End": shared.hammockOptions.zipperedPouch
      }
    },
    "STUFF_SACKS": {
      "Standard Stuff Sack": 0,
      "Stuff Sack w/ Zippered Strap Pouch": shared.components.zipperedStrapPocket
    },
    "REQUIRED_DELTA_FIELDS": [
      "Knee & Shoulder Tie Outs",
      "Under Quilt Hooks",
      "Peak Shelf",
      "Bivy Mode Tie Outs",
      "Ridgeline Gear Pouch",
      "Zippered Storage Pouch"
    ]
  },
  "trail_winder_modular_add_on": {
    "FABRICS": {
      "Ion - Black": {
        "density": shared.fabrics.quilt.ionBlack.planningDensity
      },
      "Ion - Moroccan Blue": {
        "density": shared.fabrics.quilt.ionGeneric.planningDensity
      },
      "Ion - (Choose from solid colors available at Dutchwaregear.com)": {
        "density": shared.fabrics.quilt.ionGeneric.planningDensity
      },
      "Argon 90 - Black": {
        "density": shared.fabrics.quilt.argon90Black.planningDensity
      },
      "Argon 90 - Charcoal Grey": {
        "density": shared.fabrics.quilt.argon90Charcoal.planningDensity
      },
      "Argon 90 - Dark Olive": {
        "density": shared.fabrics.quilt.argon90Generic.planningDensity
      },
      "Argon 90 - (Choose from solid colors available at Dutchwaregear.com)": {
        "density": shared.fabrics.quilt.argon90Generic.planningDensity
      },
      "Argon 67 - (Choose from solid colors available at Dutchwaregear.com)": {
        "density": shared.fabrics.quilt.argon67Generic.planningDensity
      }
    },
    "INSULATION": {
      "Apex Climashield 2.5": {
        "nominal": 2.5,
        "density": shared.insulation.apex25.planningDensity
      },
      "Apex Climashield 3.6": {
        "nominal": 3.6,
        "density": shared.insulation.apex36.planningDensity
      },
      "Apex Climashield 5.0": {
        "nominal": 5,
        "density": shared.insulation.apex50.planningDensity
      },
      "Apex Climashield 6.0": {
        "nominal": 6,
        "density": shared.insulation.apex60.planningDensity
      }
    },
    "ORIENTATIONS": {
      "Head Left / Feet Right": "Regular Asym",
      "Head Left / Feet Right (Broad Shoulders)": "Broad Shoulders",
      "Head Right / Feet Left": "Regular Asym",
      "Head Right / Feet Left (Broad Shoulders)": "Broad Shoulders",
      "Non-Asym Full Width": "Full Width"
    },
    "SHAPES": {
      "Regular Asym": {
        "area": 2712
      },
      "Broad Shoulders": {
        "area": 2856
      },
      "Full Width": {
        "area": 3744
      }
    },
    "COMPRESSION_SACK": {
      "No": false,
      "Yes": true
    },
    "ATTACHMENT_SET": 0.205333,
    "STUFF_SACK_DISPLAY": "1–1.75 oz / 28–50 g"
  },
  "trail_winder": {
    "FABRICS": {
      "Ion - Black": {
        "width": shared.fabrics.quilt.ionBlack.usableWidth,
        "ultralight": false,
        "density": shared.fabrics.quilt.ionBlack.planningDensity
      },
      "Ion - Moroccan Blue": {
        "width": shared.fabrics.quilt.ionGeneric.usableWidth,
        "ultralight": false,
        "density": shared.fabrics.quilt.ionGeneric.planningDensity
      },
      "Ion - (Choose from solid colors available at Dutchwaregear.com)": {
        "width": shared.fabrics.quilt.ionGeneric.usableWidth,
        "ultralight": false,
        "density": shared.fabrics.quilt.ionGeneric.planningDensity
      },
      "Argon 90 - Black": {
        "width": shared.fabrics.quilt.argon90Black.usableWidth,
        "ultralight": false,
        "density": shared.fabrics.quilt.argon90Black.planningDensity
      },
      "Argon 90 - Charcoal Grey": {
        "width": shared.fabrics.quilt.argon90Charcoal.usableWidth,
        "ultralight": false,
        "density": shared.fabrics.quilt.argon90Charcoal.planningDensity
      },
      "Argon 90 - Dark Olive": {
        "density": shared.fabrics.quilt.argon90Generic.planningDensity,
        "width": shared.fabrics.quilt.argon90Generic.usableWidth,
        "ultralight": false
      },
      "Argon 90 - (Choose from solid colors available at Dutchwaregear.com)": {
        "width": shared.fabrics.quilt.argon90Generic.usableWidth,
        "ultralight": false,
        "density": shared.fabrics.quilt.argon90Generic.planningDensity
      },
      "Argon 67 - (Choose from solid colors available at Dutchwaregear.com)": {
        "width": shared.overrides.trailWinder.baseArgon67Width,
        "ultralight": true,
        "density": shared.fabrics.quilt.argon67Generic.planningDensity
      }
    },
    "MODULAR_FABRICS": {
      "Argon 90 - Black": {
        "width": shared.fabrics.quilt.argon90Black.usableWidth,
        "ultralight": false,
        "density": shared.fabrics.quilt.argon90Black.planningDensity
      },
      "Argon 90 - Charcoal Grey": {
        "width": shared.fabrics.quilt.argon90Charcoal.usableWidth,
        "ultralight": false,
        "density": shared.fabrics.quilt.argon90Charcoal.planningDensity
      },
      "Argon 90 - Dark Olive": {
        "density": shared.fabrics.quilt.argon90Generic.planningDensity,
        "width": shared.fabrics.quilt.argon90Generic.usableWidth,
        "ultralight": false
      },
      "Argon 90 - (Choose from solid colors available at Dutchwaregear.com)": {
        "width": shared.fabrics.quilt.argon90Generic.usableWidth,
        "ultralight": false,
        "density": shared.fabrics.quilt.argon90Generic.planningDensity
      },
      "Argon 67 - (Choose from solid colors available at Dutchwaregear.com)": {
        "width": shared.fabrics.quilt.argon67Generic.usableWidth,
        "ultralight": true,
        "density": shared.fabrics.quilt.argon67Generic.planningDensity
      }
    },
    "LENGTHS": {
      "9'": 99,
      "10'": 111,
      "11'": 123,
      "12’": 135
    },
    "CUSTOM_LENGTH": "Custom Fit (please contact me first)",
    "ORIENTATIONS": {
      "Head Left / Feet Right": "Regular Asym",
      "Head Left / Feet Right (Broad Shoulders)": "Broad Shoulders",
      "Head Right / Feet Left": "Regular Asym",
      "Head Right / Feet Left (Broad Shoulders)": "Broad Shoulders",
      "Non-Asym Full Width": "Full Width"
    },
    "SHAPES": {
      "Regular Asym": {
        "baseArea": 2750,
        "addOnArea": 2712,
        "sackFirst": 0,
        "sackSecond": 0
      },
      "Broad Shoulders": {
        "baseArea": 2894,
        "addOnArea": 2856,
        "sackFirst": 2,
        "sackSecond": 0
      },
      "Full Width": {
        "baseArea": 3796,
        "addOnArea": 3744,
        "sackFirst": 4,
        "sackSecond": 2
      }
    },
    "INSULATION": {
      "Apex Climashield 2.5 (50°F)": {
        "nominal": 2.5,
        "density": shared.insulation.apex25.planningDensity,
        "coefficient": "2.5"
      },
      "Apex Climashield 3.6 (40°F)": {
        "nominal": 3.6,
        "density": shared.insulation.apex36.planningDensity,
        "coefficient": "3.6"
      },
      "Apex Climashield 5.0 (30°F)": {
        "nominal": 5,
        "density": shared.insulation.apex50.planningDensity,
        "coefficient": "5/6"
      },
      "Apex Climashield 6.0 (20°F)": {
        "nominal": 6,
        "density": shared.insulation.apex60.planningDensity,
        "coefficient": "5/6"
      },
      "Apex Climashield 7.5 (10°F)": {
        "nominal": 7.5,
        "density": shared.insulation.apex75.planningDensity,
        "coefficient": "7.5/10"
      },
      "Apex Climashield 10.0 (-5°F)": {
        "nominal": 10,
        "density": shared.insulation.apex100.planningDensity,
        "coefficient": "7.5/10"
      }
    },
    "MODULAR_INSULATION": {
      "Apex Climashield 2.5": {
        "nominal": 2.5,
        "density": shared.insulation.apex25.planningDensity
      },
      "Apex Climashield 3.6": {
        "nominal": 3.6,
        "density": shared.insulation.apex36.planningDensity
      },
      "Apex Climashield 5.0": {
        "nominal": 5,
        "density": shared.insulation.apex50.planningDensity
      },
      "Apex Climashield 6.0": {
        "nominal": 6,
        "density": shared.insulation.apex60.planningDensity
      }
    },
    "MODULAR": {
      "No": "none",
      "No, Snaps Only (to Future Proof)": "snaps",
      "Yes": "add-on"
    },
    "YES_NO": {
      "No": false,
      "Yes": true
    },
    "WRAP_AREAS": {
      "Regular Asym": {
        "2.5": 2.3762,
        "3.6": 2.4639,
        "5/6": 2.6434,
        "7.5/10": 2.7353
      },
      "Broad Shoulders": {
        "2.5": 2.4918,
        "3.6": 2.5809,
        "5/6": 2.7634,
        "7.5/10": 2.8569
      },
      "Full Width": {
        "2.5": 3.2207,
        "3.6": 3.321,
        "5/6": 3.5278,
        "7.5/10": 3.6343
      }
    },
    "SACK_CLASSES": [
      {
        "max": 2.5,
        "first": 20,
        "second": 20
      },
      {
        "max": 3.6,
        "first": 24,
        "second": 22
      },
      {
        "max": 5,
        "first": 26,
        "second": 22
      },
      {
        "max": 6,
        "first": 28,
        "second": 24
      },
      {
        "max": 7.5,
        "first": 32,
        "second": 26
      },
      {
        "max": 10,
        "first": 36,
        "second": 28
      },
      {
        "max": 14,
        "first": 40,
        "second": 30
      },
      {
        "max": 16,
        "first": 44,
        "second": 32
      }
    ],
    "SACK_RATE": 0.0011669117647058822,
    "NORMAL_SIDE_ASSEMBLY": 1.153,
    "UL_SIDE_ASSEMBLY": 0.658,
    "MINI_SUSPENSION": 0.727,
    "BASE_SNAP_SET": 0.16,
    "ADD_ON_ATTACHMENT_SET": 0.205333
  },
  "tree_runner": {
    "FABRICS": {
      "Hexon 1.6 - Charcoal Grey": {
        "density": shared.fabrics.hammock.hexon16.planningDensity,
        "width": shared.fabrics.hammock.hexon16.usableWidth
      },
      "Hexon 1.6 - Coyote Brown": {
        "density": shared.fabrics.hammock.hexon16.planningDensity,
        "width": shared.fabrics.hammock.hexon16.usableWidth
      },
      "Hexon 1.6 - Dark Olive": {
        "density": shared.fabrics.hammock.hexon16DarkOlive.planningDensity,
        "width": shared.fabrics.hammock.hexon16DarkOlive.usableWidth
      },
      "Hexon 1.6 - Moroccan Blue": {
        "density": shared.fabrics.hammock.hexon16Moroccan.planningDensity,
        "width": shared.fabrics.hammock.hexon16Moroccan.usableWidth
      },
      "Hexon 1.6 (Choose from colors available at Dutchwaregear.com)": {
        "density": shared.fabrics.hammock.hexon16.planningDensity,
        "width": shared.fabrics.hammock.hexon16.usableWidth
      },
      "Hexon 1.2 (Choose from colors available at Dutchwaregear.com)": {
        "density": shared.fabrics.hammock.hexon12.planningDensity,
        "width": shared.fabrics.hammock.hexon12.usableWidth
      },
      "Hexon Wide 1.6 - Dark Olive": {
        "density": shared.fabrics.hammock.hexonWide16DarkOlive.planningDensity,
        "width": shared.fabrics.hammock.hexonWide16DarkOlive.usableWidth
      },
      "Hexon Wide 1.6 (Choose from colors available at Dutchwaregear.com)": {
        "density": shared.fabrics.hammock.hexonWide16.planningDensity,
        "width": shared.fabrics.hammock.hexonWide16.usableWidth
      },
      "HyperD 1.6 (Choose from colors available at Ripstopbytheroll.com)": {
        "density": shared.fabrics.hammock.hyperD16.planningDensity,
        "width": shared.fabrics.hammock.hyperD16.usableWidth
      },
      "Monolite 1.0 (Choose from colors available at Ripstopbytheroll.com)": {
        "density": shared.fabrics.hammock.monolite10.planningDensity,
        "width": shared.fabrics.hammock.monolite10.usableWidth
      },
      "MTN 1.2 XL (Choose from colors available at Ripstopbytheroll.com)": {
        "density": shared.fabrics.hammock.mtn12XL.planningDensity,
        "width": shared.fabrics.hammock.mtn12XL.usableWidth
      },
      "MTN 1.7 XL (Choose from colors available at Ripstopbytheroll.com)": {
        "density": shared.fabrics.hammock.mtn17XL.planningDensity,
        "width": shared.fabrics.hammock.mtn17XL.usableWidth
      },
      "2.2 oz Hex70 XL (Choose from colors available at Ripstopbytheroll.com)": {
        "density": shared.fabrics.hammock.hex70XL.planningDensity,
        "width": shared.fabrics.hammock.hex70XL.usableWidth
      }
    },
    "LENGTHS": {
      "8' (great for kids)": 8,
      "9'": 9,
      "10'": 10,
      "11'": 11,
      "12'": 12
    },
    "LAYERS": {
      "Single": 1,
      "Double Without Pad Opening": 2,
      "Double With Pad Opening": 2
    },
    "DELTAS": {
      "Continuous Loops": {
        "No": 0,
        "Yes": shared.hammocks.continuousLoops.permanent
      },
      "Knotty Mod Locations": {
        "No": 0,
        "Head Right / Feet Left": 0.271,
        "Head Left / Feet Right": 0.271,
        "Both Head / Feet Locations": 0.542
      },
      "Knee & Shoulder Tie Outs": {
        "No": 0,
        "Webbing Loops": shared.hammockOptions.addOnTieLoops,
        "D-Rings": shared.hammockOptions.addOnTieDRings
      },
      "Under Quilt Hooks": {
        "No": 0,
        "Yes, UQ Hooks only": shared.hammockOptions.uqHooks,
        "Yes, UQ Hooks + D-Rings": shared.hammockOptions.uqHooksDRings
      },
      "Peak Shelf": {
        "No": 0,
        "Yes, Head End Only": shared.hammockOptions.peakShelfOne,
        "Yes, Foot End Only": shared.hammockOptions.peakShelfOne,
        "Yes, Both Head & Foot Ends": shared.hammockOptions.peakShelfBoth
      },
      "Ridgeline Gear Pouch": {
        "No": 0,
        "Yes": shared.hammockOptions.smallRidgelinePouch
      },
      "Zippered Shoulder Pouch": {
        "No": 0,
        "Yes, Left Head End": shared.hammockOptions.zipperedPouch,
        "Yes, Right Head End": shared.hammockOptions.zipperedPouch
      }
    },
    "SUSPENSIONS": {
      "None (I will use my own)": {
        "weight": shared.suspension.none.weight,
        "sack": shared.suspension.none.sack
      },
      "Cinch Buckle": {
        "weight": shared.suspension.cinchBuckleNonStarter.weight,
        "sack": shared.suspension.cinchBuckleNonStarter.sack
      },
      "Whoopies/Straps/Toggles": {
        "weight": shared.suspension.whoopieToggle.weight,
        "sack": shared.suspension.whoopieToggle.sack
      },
      "Whoopies/Straps/Carabiners (1 Blue, 1 Orange)": {
        "weight": shared.suspension.whoopieCarabiner.weight,
        "sack": shared.suspension.whoopieCarabiner.sack
      },
      "Whoopies/Straps/Dutch Whoopie Hooks": {
        "weight": shared.suspension.whoopieHook.weight,
        "sack": shared.suspension.whoopieHook.sack
      },
      "Dutch Beetle Buckles (w/12' Black Straps and sewn Dutch Clips)": {
        "weight": shared.suspension.beetleBuckle.weight,
        "sack": shared.suspension.beetleBuckle.sack
      }
    }
  },
  "voyageur": {
    "FABRICS": {
      "Hexon 1.6 - Charcoal Grey": {
        "density": shared.fabrics.hammock.hexon16.planningDensity,
        "width": shared.fabrics.hammock.hexon16.usableWidth,
        "hood": 0.4176666667
      },
      "Hexon 1.6 - Coyote Brown": {
        "density": shared.fabrics.hammock.hexon16.planningDensity,
        "hood": 0.4176666667,
        "width": shared.fabrics.hammock.hexon16.usableWidth
      },
      "Hexon 1.6 - Dark Olive": {
        "density": shared.fabrics.hammock.hexon16DarkOlive.planningDensity,
        "width": shared.fabrics.hammock.hexon16DarkOlive.usableWidth,
        "hood": 0.4176666667
      },
      "Hexon 1.6 - Moroccan Blue": {
        "density": shared.fabrics.hammock.hexon16Moroccan.planningDensity,
        "hood": 0.4176666667,
        "width": shared.fabrics.hammock.hexon16Moroccan.usableWidth
      },
      "Hexon 1.6 (Choose from colors available at Dutchwaregear.com)": {
        "hood": 0.4176666667,
        "density": shared.fabrics.hammock.hexon16.planningDensity,
        "width": shared.fabrics.hammock.hexon16.usableWidth
      },
      "Hexon 1.2 (Choose from colors available at Dutchwaregear.com)": {
        "hood": 0.3115,
        "density": shared.fabrics.hammock.hexon12.planningDensity,
        "width": shared.fabrics.hammock.hexon12.usableWidth
      },
      "Hexon Wide 1.6 - Dark Olive": {
        "density": shared.fabrics.hammock.hexonWide16DarkOlive.planningDensity,
        "hood": 0.4176666667,
        "width": shared.fabrics.hammock.hexonWide16DarkOlive.usableWidth
      },
      "Hexon Wide 1.6 (Choose from colors available at Dutchwaregear.com)": {
        "hood": 0.4176666667,
        "density": shared.fabrics.hammock.hexonWide16.planningDensity,
        "width": shared.fabrics.hammock.hexonWide16.usableWidth
      },
      "HyperD 1.6 (Choose from colors available at Ripstopbytheroll.com)": {
        "density": shared.fabrics.hammock.hyperD16.planningDensity,
        "width": shared.fabrics.hammock.hyperD16.usableWidth
      },
      "Monolite 1.0 (Choose from colors available at Ripstopbytheroll.com)": {
        "hood": 0.2645,
        "density": shared.fabrics.hammock.monolite10.planningDensity,
        "width": shared.fabrics.hammock.monolite10.usableWidth
      },
      "MTN 1.2 XL (Choose from colors available at Ripstopbytheroll.com)": {
        "density": shared.fabrics.hammock.mtn12XL.planningDensity,
        "width": shared.fabrics.hammock.mtn12XL.usableWidth
      },
      "MTN 1.7 XL (Choose from colors available at Ripstopbytheroll.com)": {
        "density": shared.fabrics.hammock.mtn17XL.planningDensity,
        "width": shared.fabrics.hammock.mtn17XL.usableWidth
      },
      "2.2 oz Hex70 XL (Choose from colors available at Ripstopbytheroll.com)": {
        "density": shared.fabrics.hammock.hex70XL.planningDensity,
        "width": shared.fabrics.hammock.hex70XL.usableWidth
      }
    },
    "LENGTHS": {
      "9’": 9,
      "10’": 10,
      "11’": 11,
      "12’": 12
    },
    "LAYERS": {
      "Single": 1,
      "Double Without Pad Opening": 2,
      "Double With Pad Opening": 2
    },
    "HOOD_COLORS": {
      "Matching": null,
      "Black": 0.4176667,
      "Burnt Orange": 0.4176667,
      "Charcoal Grey": 0.4176667,
      "Coyote Brown": 0.4176667,
      "Dark Olive": 0.4176667,
      "Moroccan Blue": 0.4176667
    },
    "RIDGELINES": {
      "None (I will use my own)": "none",
      "Yes, Fixed (AmSteel)": "fixed",
      "Yes, Adjustable": "adjustable"
    },
    "SUSPENSIONS": {
      "None (I will use my own)": {
        "weight": shared.suspension.none.weight,
        "sack": shared.suspension.none.sack,
        "includesLoops": shared.suspension.none.includesLoops
      },
      "Cinch Buckle": {
        "weight": shared.suspension.cinchBuckleNonStarter.weight,
        "sack": shared.suspension.cinchBuckleNonStarter.sack,
        "includesLoops": shared.suspension.cinchBuckleNonStarter.includesLoops
      },
      "Whoopies/Straps/Toggles": {
        "weight": shared.suspension.whoopieToggle.weight,
        "sack": shared.suspension.whoopieToggle.sack,
        "includesLoops": shared.suspension.whoopieToggle.includesLoops
      },
      "Whoopies/Straps/Carabiners (1 Blue, 1 Orange)": {
        "weight": shared.suspension.whoopieCarabiner.weight,
        "sack": shared.suspension.whoopieCarabiner.sack,
        "includesLoops": shared.suspension.whoopieCarabiner.includesLoops
      },
      "Whoopies/Straps/Dutch Whoopie Hooks": {
        "includesLoops": shared.suspension.whoopieHook.includesLoops,
        "weight": shared.suspension.whoopieHook.weight,
        "sack": shared.suspension.whoopieHook.sack
      },
      "Dutch Beetle Buckles (w/12' Black Straps and sewn Dutch Clips)": {
        "weight": shared.suspension.beetleBuckle.weight,
        "sack": shared.suspension.beetleBuckle.sack,
        "includesLoops": shared.suspension.beetleBuckle.includesLoops
      }
    },
    "CONTINUOUS_LOOPS": {
      "No": 0,
      "Yes, Removable (larksheaded through end channels)": shared.hammocks.continuousLoops.removable,
      "Yes, Permanent (crafted into end channels)": shared.hammocks.continuousLoops.permanent
    },
    "DELTAS": {
      "Knee & Shoulder Tie Outs": {
        "No": 0,
        "Webbing Loops": shared.hammockOptions.addOnTieLoops,
        "D-Rings": shared.hammockOptions.addOnTieDRings
      },
      "Under Quilt Hooks": {
        "No": 0,
        "Yes, UQ Hooks only": shared.hammockOptions.uqHooks,
        "Yes, UQ Hooks + D-Rings": shared.hammockOptions.uqHooksDRings
      },
      "Peak Shelf": {
        "No": 0,
        "Yes, Head End Only": shared.hammockOptions.peakShelfOne,
        "Yes, Foot End Only": shared.hammockOptions.peakShelfOne,
        "Yes, Both Head & Foot Ends": shared.hammockOptions.peakShelfBoth
      },
      "Ridgeline Gear Pouch": {
        "No": 0,
        "Yes": shared.hammockOptions.smallRidgelinePouch
      },
      "Zippered Shoulder Pouch": {
        "No": 0,
        "Yes, Left Head End": shared.hammockOptions.zipperedPouch,
        "Yes, Right Head End": shared.hammockOptions.zipperedPouch
      }
    },
    "STUFF_SACKS": {
      "Standard Stuff Sack": 0,
      "Stuff Sack w/ Zippered Strap Pouch": shared.hammockOptions.zipperedStrapSack
    },
    "REQUIRED_DELTA_FIELDS": [
      "Knee & Shoulder Tie Outs",
      "Under Quilt Hooks",
      "Peak Shelf",
      "Ridgeline Gear Pouch",
      "Zippered Shoulder Pouch"
    ]
  },
  "wind_haven": {
    "FABRICS": {
      "Silnylon 1.1 - Dark Olive": {
        "density": shared.fabrics.tarp.darkOliveSilnylon.planningDensity,
        "usableWidth": shared.fabrics.tarp.darkOliveSilnylon.usableWidth
      },
      "Silnylon 1.1 (Choose from colors available at Dutchwaregear.com)": {
        "usableWidth": shared.fabrics.tarp.silnylon11Generic.usableWidth,
        "density": shared.fabrics.tarp.silnylon11Generic.planningDensity
      },
      "Xenon Sil 1.1 - Charcoal Grey": {
        "usableWidth": shared.fabrics.tarp.xenon11Charcoal.usableWidth,
        "density": shared.fabrics.tarp.xenon11Charcoal.planningDensity
      },
      "Xenon Sil 1.1 - Coyote Brown": {
        "usableWidth": shared.fabrics.tarp.xenon11Coyote.usableWidth,
        "density": shared.fabrics.tarp.xenon11Coyote.planningDensity
      },
      "Xenon Sil 1.1 - Moroccan Blue": {
        "usableWidth": shared.fabrics.tarp.xenon11Moroccan.usableWidth,
        "density": shared.fabrics.tarp.xenon11Moroccan.planningDensity
      },
      "Xenon Sil 1.1 (Choose from colors available at Dutchwaregear.com)": {
        "density": shared.fabrics.tarp.xenon11Ordered.planningDensity,
        "usableWidth": shared.fabrics.tarp.xenon11Ordered.usableWidth
      },
      "Silpoly 1.1 (Choose from available solid colors at Ripstopbytheroll.com)": {
        "usableWidth": shared.fabrics.tarp.silpoly11Generic.usableWidth,
        "density": shared.fabrics.tarp.silpoly11Generic.planningDensity
      },
      "Silpoly 1.6 (Choose from available solid colors at Ripstopbytheroll.com)": {
        "density": shared.fabrics.tarp.silpoly16Generic.planningDensity,
        "usableWidth": shared.fabrics.tarp.silpoly16Generic.usableWidth
      }
    },
    "LENGTHS": {
      "10'": 10,
      "11'": 11,
      "12'": 12,
      "13'": 13
    },
    "WIDTHS": {
      "84\"": 84,
      "96\"": 96
    },
    "EDGES": {
      "Straight": {
        "extraMidpoints": false,
        "catenary": false
      },
      "Catenary Cut": {
        "extraMidpoints": false,
        "catenary": true
      },
      "Straight w/ Extra Center Point Tie Outs": {
        "catenary": false,
        "extraMidpoints": true
      }
    },
    "GROUND_HARDWARE": {
      "Loops Only": shared.components.groundHardware.loopOnly.weight,
      "Line Loc 3's": shared.components.groundHardware.lineLoc3.weight,
      "Line Lock V's": shared.components.groundHardware.lineLockV.weight,
      "Line Lock Lites (10mm)": shared.components.groundHardware.lineLockLite10.weight,
      "Line Lock Lites (15mm)": shared.components.groundHardware.lineLockLite15.weight,
      "D-Rings": shared.components.groundHardware.dRing.weight
    },
    "SIDE_PULLS": {
      "None": false,
      "Yes": true,
      "Yes, Bridge Hammock Spacing (78\")": true,
      "Standard Spacing — D-Rings": true,
      "Standard Spacing — Webbing Loops": "webbingLoops",
      "Bridge Hammock Spacing — D-Rings": true,
      "Bridge Hammock Spacing — Webbing Loops": "webbingLoops"
    },
    "DOOR_ENDS": {
      "Standard Doors (NO Snaps)": false,
      "With Snaps": true
    },
    "INTERNAL_RIDGELINE": {
      "No": false,
      "Yes (not needed if you add the pole set)": true
    },
    "GLOWIRE": {
      "None (I will use my own)": shared.accessories.none,
      "25’ Lawson Equipment Glowire - Orange Reflective": shared.accessories.glowire25,
      "50’ Lawson Equipment Glowire - Orange Reflective": shared.accessories.glowire50
    },
    "RIDGELINE_CORD": {
      "None (I will use my own)": shared.accessories.none,
      "25' of 1.75mm Zing-It": shared.accessories.zingIt25,
      "Pair of Dutch Tarp Flyz (No Cord)": shared.accessories.tarpFlyzPair,
      "Pair of Flyz spliced to (2) 12' Yellow Zing-It lines": shared.accessories.flyzSplicedZingItPair,
      "Pair of Flyz spliced to (2) 12' Grey Lash-It lines": shared.accessories.flyzSplicedLashItPair
    },
    "POLES": {
      "No": 0,
      "Single Pole": 1,
      "Double Pole": 2,
      "Triple Pole": 3
    },
    "STAKES": {
      "None (I will use my own)": 0,
      "(8) 7\" Aluminum Y-Stakes": 3.789,
      "(8) 6.5\" UL Titanium Stakes": 2.0396666666666667
    },
    "PATCH_KIT": {
      "No": 0,
      "Yes": shared.accessories.patchKit
    }
  },
  "winter_haven": {
    "FABRICS": {
      "Silnylon 1.1 - Dark Olive": {
        "className": "standard",
        "density": shared.fabrics.tarp.darkOliveSilnylon.planningDensity,
        "usableWidth": shared.fabrics.tarp.darkOliveSilnylon.usableWidth
      },
      "Silnylon 1.1 (Choose from colors available at Dutchwaregear.com)": {
        "usableWidth": shared.fabrics.tarp.silnylon11Generic.usableWidth,
        "className": "standard",
        "density": shared.fabrics.tarp.silnylon11Generic.planningDensity
      },
      "Xenon Sil 1.1 - Charcoal Grey": {
        "usableWidth": shared.fabrics.tarp.xenon11Charcoal.usableWidth,
        "className": "standard",
        "density": shared.fabrics.tarp.xenon11Charcoal.planningDensity
      },
      "Xenon Sil 1.1 - Coyote Brown": {
        "usableWidth": shared.fabrics.tarp.xenon11Coyote.usableWidth,
        "className": "standard",
        "density": shared.fabrics.tarp.xenon11Coyote.planningDensity
      },
      "Xenon Sil 1.1 - Moroccan Blue": {
        "usableWidth": shared.fabrics.tarp.xenon11Moroccan.usableWidth,
        "className": "standard",
        "density": shared.fabrics.tarp.xenon11Moroccan.planningDensity
      },
      "Xenon Sil 1.1 (Choose from colors available at Dutchwaregear.com)": {
        "usableWidth": shared.fabrics.tarp.xenon11Ordered.usableWidth,
        "className": "standard",
        "density": shared.fabrics.tarp.xenon11Ordered.planningDensity
      },
      "Xenon Sil Wide (Choose from colors available at Dutchwaregear.com)": {
        "usableWidth": shared.fabrics.tarp.xenonWide.usableWidth,
        "density": shared.fabrics.tarp.xenonWide.planningDensity,
        "className": "wide"
      },
      "Silpoly 1.1 (Choose from available solid colors at Ripstopbytheroll.com)": {
        "usableWidth": shared.fabrics.tarp.silpoly11Generic.usableWidth,
        "className": "standard",
        "density": shared.fabrics.tarp.silpoly11Generic.planningDensity
      },
      "Silpoly 1.6 (Choose from available solid colors at Ripstopbytheroll.com)": {
        "density": shared.fabrics.tarp.silpoly16Generic.planningDensity,
        "usableWidth": shared.fabrics.tarp.silpoly16Generic.usableWidth,
        "className": "standard"
      },
      "Silpoly XL (Choose from available solid colors at Ripstopbytheroll.com)": {
        "usableWidth": shared.fabrics.tarp.silpolyXLGeneric.usableWidth,
        "density": shared.fabrics.tarp.silpolyXLGeneric.planningDensity,
        "className": "wide"
      }
    },
    "LENGTHS": {
      "10'": 10,
      "11'": 11,
      "12'": 12,
      "13'": 13
    },
    "EDGES": {
      "Straight": {
        "extraMidpoints": false,
        "catenary": false
      },
      "Catenary Cut": {
        "extraMidpoints": false,
        "catenary": true
      },
      "Straight w/ Extra Center Point Tie Outs": {
        "catenary": false,
        "extraMidpoints": true
      }
    },
    "GROUND_HARDWARE": {
      "Loops Only": 0,
      "Line Loc 3's": 0.044,
      "Line Lock V's": 0.041,
      "Line Lock Lites (10mm)": 0.039,
      "Line Lock Lites (15mm)": 0.038,
      "D-Rings": 0.064
    },
    "SIDE_PULLS": {
      "None": false,
      "Yes": true,
      "Yes, Bridge Hammock Spacing (78\")": true,
      "Standard Spacing — D-Rings": true,
      "Standard Spacing — Webbing Loops": "webbingLoops",
      "Bridge Hammock Spacing — D-Rings": true,
      "Bridge Hammock Spacing — Webbing Loops": "webbingLoops"
    },
    "DOOR_ENDS": {
      "Standard Doors (NO Snaps)": false,
      "With Snaps": true
    },
    "INTERNAL_RIDGELINE": {
      "No": false,
      "Yes (not needed if you add the pole set)": true
    },
    "GLOWIRE": {
      "None (I will use my own)": shared.accessories.none,
      "25’ Lawson Equipment Glowire - Orange Reflective": shared.accessories.glowire25,
      "50’ Lawson Equipment Glowire - Orange Reflective": shared.accessories.glowire50
    },
    "RIDGELINE_CORD": {
      "None (I will use my own)": shared.accessories.none,
      "25' of 1.75mm Zing-It": shared.accessories.zingIt25,
      "Pair of Dutch Tarp Flyz (No Cord)": shared.accessories.tarpFlyzPair,
      "Pair of Flyz spliced to (2) 12' Yellow Zing-It lines": shared.accessories.flyzSplicedZingItPair,
      "Pair of Flyz spliced to (2) 12' Grey Lash-It lines": shared.accessories.flyzSplicedLashItPair
    },
    "POLES": {
      "No": 0,
      "Single Pole": 1,
      "Double Pole": 2,
      "Triple Pole": 3
    },
    "STAKES": {
      "None (I will use my own)": 0,
      "(8) 7\" Aluminum Y-Stakes": 3.789,
      "(8) 6.5\" UL Titanium Stakes": 2.0396666666666667
    },
    "PATCH_KIT": {
      "No": 0,
      "Yes": shared.accessories.patchKit
    }
  }
});
root.SLDEstimatorData=Object.freeze({schemaVersion:'2026-10-23.1',engineeringDatabaseVersion:'2.65',engineeringLibraryVersion:147,stakeSackEngineeringSource:Object.freeze({databaseVersion:'2.57',libraryRevision:134,source:'libfile_1978aa4711688191bcadcde46a43a9c9'}),poleSackEngineeringSource:Object.freeze({databaseVersion:'2.58',libraryRevision:136,source:'libfile_1978aa4711688191bcadcde46a43a9c9'}),shared,productControls,products});})(window);





